(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8329,5664],{

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fcreate-wiki%2Findex.tsx&page=%2Fcreate-wiki!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-wiki",
      function () {
        return __webpack_require__("./src/pages/create-wiki/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Wiki/WikiPreviewCard/WikiPreviewCard.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _utils_DataTransform_getFormattedDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/utils/DataTransform/getFormattedDate.ts");
/* harmony import */ var _components_Elements_Avatar_DisplayAvatar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
/* harmony import */ var _hooks_useENSData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/hooks/useENSData.ts");
/* harmony import */ var _utils_textUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/textUtils.ts");
/* harmony import */ var _components_Elements__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/components/Elements/index.ts");
/* harmony import */ var _components_Elements_LinkElements_LinkOverlay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");
/* harmony import */ var _utils_DataTransform_getUsername__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/DataTransform/getUsername.ts");
/* harmony import */ var _utils_WikiUtils_getWikiImageUrl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
/* harmony import */ var _data_Constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./src/data/Constants.ts");
/* harmony import */ var _components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/components/Elements/Image/Image.tsx");













const WikiPreviewCard = (param)=>{
    let { wiki , showLatestEditor =false , lastUpdated  } = param;
    var ref, ref1, ref2, ref3, ref4;
    const { updated , title , id  } = wiki;
    const [, userENSDomain] = (0,_hooks_useENSData__WEBPACK_IMPORTED_MODULE_3__/* .useENSData */ .L)(((ref = wiki.user) === null || ref === void 0 ? void 0 : ref.id) || "");
    const getLatestEdited = ()=>{
        let lastEditedTime = null;
        if (updated) {
            lastEditedTime = (0,_utils_DataTransform_getFormattedDate__WEBPACK_IMPORTED_MODULE_10__/* .getReadableDate */ ._)(updated);
        } else if (lastUpdated) {
            lastEditedTime = (0,_utils_DataTransform_getFormattedDate__WEBPACK_IMPORTED_MODULE_10__/* .getReadableDate */ ._)(lastUpdated);
        }
        return lastEditedTime;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .LinkBox */ .fG, {
        w: "100%",
        h: "100%",
        bgColor: "cardBg",
        boxShadow: "xl",
        rounded: "lg",
        overflow: "hidden",
        cursor: "pointer",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .AspectRatio */ .oM, {
                w: "100%",
                ratio: _data_Constants__WEBPACK_IMPORTED_MODULE_12__/* .WIKI_IMAGE_ASPECT_RATIO */ .ag,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_Image_Image__WEBPACK_IMPORTED_MODULE_9__/* .Image */ .E, {
                    src: (0,_utils_WikiUtils_getWikiImageUrl__WEBPACK_IMPORTED_MODULE_8__/* .getWikiImageUrl */ .A)(wiki.images),
                    alt: wiki.title,
                    boxSize: "100%",
                    imgBoxSize: _data_Constants__WEBPACK_IMPORTED_MODULE_12__/* .IMAGE_BOX_SIZE */ .xh
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Stack */ .Kq, {
                spacing: 3,
                p: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_LinkElements_LinkOverlay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        href: "/wiki/".concat(id),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                            fontSize: "xl",
                            fontWeight: "bold",
                            noOfLines: 1,
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            orientation: "vertical",
                            children: (0,_utils_textUtils__WEBPACK_IMPORTED_MODULE_4__/* .shortenText */ .El)(title, 65)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .kC, {
                        h: "95",
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                flex: "1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                    fontSize: "md",
                                    opacity: 0.7,
                                    noOfLines: 2,
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    orientation: "vertical",
                                    children: wiki.summary
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Spacer */ .LZ, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .HStack */ .Ug, {
                                    flexWrap: "wrap",
                                    mt: 2,
                                    justify: "space-between",
                                    children: [
                                        showLatestEditor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .HStack */ .Ug, {
                                            fontSize: "sm",
                                            py: 2,
                                            color: "brandLinkColor",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements_Avatar_DisplayAvatar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    address: (ref1 = wiki.user) === null || ref1 === void 0 ? void 0 : ref1.id,
                                                    avatarIPFS: (ref2 = wiki.user.profile) === null || ref2 === void 0 ? void 0 : ref2.avatar,
                                                    alt: (ref3 = wiki.user.profile) === null || ref3 === void 0 ? void 0 : ref3.username
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Elements__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
                                                    href: "/account/".concat((ref4 = wiki.user) === null || ref4 === void 0 ? void 0 : ref4.id),
                                                    children: (0,_utils_DataTransform_getUsername__WEBPACK_IMPORTED_MODULE_7__/* .getUsername */ .M)(wiki.user, userENSDomain)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                            py: 2,
                                            m: "0px !important",
                                            color: "gray.400",
                                            fontSize: "sm",
                                            children: [
                                                "Last Edited ",
                                                getLatestEdited()
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WikiPreviewCard);


/***/ }),

/***/ "./src/components/WrapperRoutes/AuthenticatedRoute.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ authenticatedRoute; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/next/router.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/wagmi/dist/index.js");




const WagmiLoadedAuthenticatedRoute = (param)=>{
    let { WrappedComponent , ...props } = param;
    const { address: userAddress  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_3__/* .useAccount */ .mA)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!userAddress) {
            router.push({
                pathname: "/login",
                query: {
                    from: router.asPath
                }
            });
        }
    }, [
        userAddress,
        router
    ]);
    if (userAddress) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, {
            ...props
        });
    }
    return null;
};
const authenticatedRoute = (WrappedComponent)=>{
    const AuthenticatedRoute = (props)=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WagmiLoadedAuthenticatedRoute, {
                WrappedComponent: WrappedComponent,
                ...props
            })
        });
    };
    return AuthenticatedRoute;
};


/***/ }),

/***/ "./src/data/NetworkMap.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var viem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/viem/dist/esm/index.js");

const networkMap = {
    POLYGON_MAINNET: {
        chainId: (0,viem__WEBPACK_IMPORTED_MODULE_0__/* .toHex */ .NCw)(137),
        chainName: "Matic(Polygon) Mainnet",
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18
        },
        rpcUrls: [
            "https://polygon-rpc.com/"
        ],
        blockExplorerUrls: [
            "https://www.polygonscan.com/"
        ]
    },
    MUMBAI_TESTNET: {
        chainId: (0,viem__WEBPACK_IMPORTED_MODULE_0__/* .toHex */ .NCw)(80001),
        chainName: "Matic(Polygon) Mumbai Testnet",
        nativeCurrency: {
            name: "tMATIC",
            symbol: "tMATIC",
            decimals: 18
        },
        rpcUrls: [
            "https://matic-mumbai.chainstacklabs.com/"
        ],
        blockExplorerUrls: [
            "https://mumbai.polygonscan.com/"
        ]
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (networkMap);


/***/ }),

/***/ "./src/pages/create-wiki/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ create_wiki; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("./node_modules/next/dynamic.js");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/skeleton/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js + 3 modules
var hooks_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 1 modules
var toast_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/toast/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 6 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__("./node_modules/react-redux/es/index.js");
// EXTERNAL MODULE: ./src/utils/CreateWikiUtils/saveImage.ts
var saveImage = __webpack_require__("./src/utils/CreateWikiUtils/saveImage.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 52 modules
var modal_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/modal/dist/index.esm.js");
// EXTERNAL MODULE: ./src/store/hook.ts
var hook = __webpack_require__("./src/store/hook.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var system_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/data/TagsSuggestions.ts
const TagsSuggestions = [
    {
        label: "Artists",
        value: "Artists"
    },
    {
        label: "AI",
        value: "AI"
    },
    {
        label: "BinanceSmartChain",
        value: "BinanceSmartChain"
    },
    {
        label: "Blockchains",
        value: "Blockchains"
    },
    {
        label: "CEXes",
        value: "CEXes"
    },
    {
        label: "Collections",
        value: "Collections"
    },
    {
        label: "Collectors",
        value: "Collectors"
    },
    {
        label: "DEXes",
        value: "DEXes"
    },
    {
        label: "Developers",
        value: "Developers"
    },
    {
        label: "Entertainment",
        value: "Entertainment"
    },
    {
        label: "Ethereum",
        value: "Ethereum"
    },
    {
        label: "Founders",
        value: "Founders"
    },
    {
        label: "Games",
        value: "Games"
    },
    {
        label: "Glossary",
        value: "Glossary"
    },
    {
        label: "Marketplaces",
        value: "Marketplaces"
    },
    {
        label: "Memecoins",
        value: "Memecoins"
    },
    {
        label: "Organizations",
        value: "Organizations"
    },
    {
        label: "PeopleInDeFi",
        value: "PeopleInDeFi"
    },
    {
        label: "Polkadot",
        value: "Polkadot"
    },
    {
        label: "Polygon",
        value: "Polygon"
    },
    {
        label: "Protocols",
        value: "Protocols"
    },
    {
        label: "Solana",
        value: "Solana"
    },
    {
        label: "Stablecoins",
        value: "Stablecoins"
    },
    {
        label: "Venture",
        value: "Venture"
    }
];

// EXTERNAL MODULE: ./node_modules/chakra-react-select/dist/esm/select.js + 60 modules
var esm_select = __webpack_require__("./node_modules/chakra-react-select/dist/esm/select.js");
;// CONCATENATED MODULE: ./src/components/CreateWiki/EditorModals/EditWikiDetailsModal/TagsInput.tsx






const TagsInput = (param)=>{
    let { wiki  } = param;
    const dispatch = (0,hook/* useAppDispatch */.T)();
    const [value, setValue] = (0,react.useState)(wiki.tags.map((ta)=>({
            label: ta.id,
            value: ta.id
        })));
    const handleOnchange = (item)=>{
        setValue(item);
        dispatch({
            type: "wiki/setTags",
            payload: item.map((ta)=>({
                    id: ta.value
                }))
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
        spacing: "4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                fontWeight: "semibold",
                children: [
                    "Tags ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                        opacity: 0.4,
                        children: "(Add up to 5)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.div */.m$.div, {
                zIndex: "999",
                rounded: "md",
                borderWidth: 1,
                p: 2,
                pos: "relative",
                maxH: "max-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_select/* default */.Z, {
                    isOptionDisabled: ()=>value.length >= 5,
                    placeholder: "Add tags...",
                    variant: "unstyled",
                    isMulti: true,
                    size: "sm",
                    options: TagsSuggestions,
                    onChange: (item)=>handleOnchange(item),
                    defaultValue: wiki.tags.map((ta)=>({
                            label: ta.id,
                            value: ta.id
                        }))
                })
            })
        ]
    });
};
/* harmony default export */ var EditWikiDetailsModal_TagsInput = (/*#__PURE__*/(0,react.memo)(TagsInput));

// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/data/WikiLinks.ts + 11 modules
var WikiLinks = __webpack_require__("./src/data/WikiLinks.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/index.esm.js
var select_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/select/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/input/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/CreateWiki/EditorModals/EditWikiDetailsModal/LinksInput.tsx







const LinksInput = (param)=>{
    let { wiki  } = param;
    const [currentLink, setCurrentLink] = (0,react.useState)();
    const [currentLinkValue, setCurrentLinkValue] = (0,react.useState)();
    const [error, setError] = (0,react.useState)("");
    const dispatch = (0,hook/* useAppDispatch */.T)();
    const getWikiAttribute = (attr)=>{
        var ref;
        const attribute = (ref = wiki.metadata.find((att)=>att.id === attr)) === null || ref === void 0 ? void 0 : ref.value;
        return {
            isDefined: !!attribute,
            value: attribute
        };
    };
    const updateLink = (network, link)=>{
        if (network && link) {
            dispatch({
                type: "wiki/updateMetadata",
                payload: {
                    id: network,
                    value: link
                }
            });
            setCurrentLink("");
            setCurrentLinkValue("");
        }
    };
    const insertLinks = ()=>{
        if (currentLinkValue) {
            var ref;
            const link = WikiLinks/* LINK_OPTIONS.find */.c.find((l)=>l.id === currentLink);
            if (currentLinkValue.length > Constants/* WIKI_METADATA_VALUE_LIMIT */.L) {
                setError("Link exceeds limit of ".concat(Constants/* WIKI_METADATA_VALUE_LIMIT */.L, "."));
                return;
            }
            const linkIsValid = link === null || link === void 0 ? void 0 : (ref = link.tests) === null || ref === void 0 ? void 0 : ref.some((t)=>t.test(currentLinkValue));
            if (linkIsValid) {
                updateLink(currentLink, currentLinkValue);
                setError("");
            } else {
                setError("Invalid ".concat(link === null || link === void 0 ? void 0 : link.label, " url format"));
            }
        }
    };
    const linksWithValue = WikiLinks/* LINK_OPTIONS.filter */.c.filter((med)=>{
        var ref;
        return !!((ref = wiki.metadata.find((m)=>m.id === med.id)) === null || ref === void 0 ? void 0 : ref.value);
    });
    const removeLink = (network)=>{
        dispatch({
            type: "wiki/updateMetadata",
            payload: {
                id: network,
                value: ""
            }
        });
    };
    const atttributeExists = (attr)=>attr ? getWikiAttribute(attr).isDefined : false;
    react.useEffect(()=>{
        if (currentLink && atttributeExists(currentLink)) setCurrentLinkValue(getWikiAttribute(currentLink).value);
        else setCurrentLinkValue("");
        setError("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentLink
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
        rounded: "md",
        _dark: {
            borderColor: "whiteAlpha.300"
        },
        spacing: "2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontWeight: "semibold",
                children: "Links"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                borderColor: "gray.200",
                _dark: {
                    borderColor: "whiteAlpha.200"
                },
                gap: "2",
                gridTemplateColumns: {
                    base: "1fr 2fr",
                    md: "1.2fr 2fr 0.8fr"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                        h: "40px",
                        rounded: "md",
                        flex: "5.5",
                        value: currentLink,
                        onChange: (event)=>{
                            const attr = event.target.value;
                            setCurrentLink(attr);
                        },
                        placeholder: "Select option",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("optgroup", {
                                label: "Socials",
                                children: WikiLinks/* LINK_OPTIONS.filter */.c.filter((option)=>option.type === WikiLinks/* LinkType.SOCIAL */.U.SOCIAL).map((med)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.option */.m$.option, {
                                        value: med.id,
                                        children: med.label
                                    }, med.id))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("optgroup", {
                                label: "Explorers",
                                children: WikiLinks/* LINK_OPTIONS.filter */.c.filter((option)=>option.type === WikiLinks/* LinkType.EXPLORER */.U.EXPLORER).map((med)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.option */.m$.option, {
                                        value: med.id,
                                        children: med.label
                                    }, med.id))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("optgroup", {
                                label: "Other",
                                children: WikiLinks/* LINK_OPTIONS.filter */.c.filter((option)=>option.type !== WikiLinks/* LinkType.SOCIAL */.U.SOCIAL && option.type !== WikiLinks/* LinkType.EXPLORER */.U.EXPLORER).map((med)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.option */.m$.option, {
                                        value: med.id,
                                        children: med.label
                                    }, med.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                        disabled: !currentLink,
                        h: "40px",
                        rounded: "md",
                        placeholder: "Enter link",
                        value: currentLinkValue,
                        onChange: (event)=>setCurrentLinkValue(event.target.value),
                        type: "url"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                        disabled: !currentLink,
                        rounded: "md",
                        onClick: insertLinks,
                        minW: {
                            base: "full",
                            md: "110px"
                        },
                        h: "40px",
                        gridColumn: {
                            base: "span 2",
                            md: "unset"
                        },
                        children: atttributeExists(currentLink) ? "Update" : "Add"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                color: "red.300",
                children: error
            }),
            linksWithValue.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Wrap */.Eq, {
                gap: "1",
                children: linksWithValue.map((network)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Button */.zx, {
                        display: "flex",
                        gap: 2,
                        onClick: ()=>setCurrentLink(network.id),
                        "aria-label": network.label,
                        bg: "gray.100",
                        color: "black",
                        _hover: {
                            bg: "gray.100"
                        },
                        _dark: {
                            color: "white",
                            bg: "whiteAlpha.100"
                        },
                        rounded: "md",
                        size: "xs",
                        px: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        as: network.icon
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontWeight: "normal",
                                        fontSize: "xs",
                                        children: network.label
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                boxSize: 4,
                                fontSize: "xs",
                                fontWeight: "bold",
                                lineHeight: "none",
                                color: "red.100",
                                bg: "red.400",
                                _hover: {
                                    bg: "red.500"
                                },
                                rounded: "full",
                                onClick: ()=>removeLink(network.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                    as: ri_index_esm/* RiCloseLine */.eSQ
                                })
                            })
                        ]
                    }, network.id))
            })
        ]
    });
};
/* harmony default export */ var EditWikiDetailsModal_LinksInput = (LinksInput);

// EXTERNAL MODULE: ./src/services/categories/index.ts + 1 modules
var categories = __webpack_require__("./src/services/categories/index.ts");
// EXTERNAL MODULE: ./src/utils/textUtils.ts
var textUtils = __webpack_require__("./src/utils/textUtils.ts");
;// CONCATENATED MODULE: ./src/components/CreateWiki/EditorModals/EditWikiDetailsModal/CategoryInput.tsx






const CategoryInput = (param)=>{
    let { wiki  } = param;
    var ref;
    const dispatch = (0,hook/* useAppDispatch */.T)();
    const { data: categoryOptions  } = (0,categories/* useGetCategoriesLinksQuery */.$3)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        gap: "2.5",
        align: "start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontWeight: "semibold",
                children: "Category"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_dist_index_esm/* Select */.Ph, {
                size: "sm",
                rounded: "md",
                maxW: "52",
                ml: "auto",
                onChange: (event)=>{
                    if (event.target.value) {
                        dispatch({
                            type: "wiki/updateCategories",
                            payload: {
                                id: (0,textUtils/* slugifyText */.Ei)(event.target.value),
                                title: event.target.value
                            }
                        });
                    } else {
                        dispatch({
                            type: "wiki/deleteCategories"
                        });
                    }
                },
                value: (ref = wiki.categories[0]) === null || ref === void 0 ? void 0 : ref.id,
                placeholder: wiki.categories.length > 0 ? undefined : "Select Category",
                children: categoryOptions === null || categoryOptions === void 0 ? void 0 : categoryOptions.map((o)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: o.id,
                        children: o.title
                    }, o.id))
            })
        ]
    });
};
/* harmony default export */ var EditWikiDetailsModal_CategoryInput = (CategoryInput);

// EXTERNAL MODULE: ./node_modules/@everipedia/iq-utils/build/module/index.js + 2 modules
var build_module = __webpack_require__("./node_modules/@everipedia/iq-utils/build/module/index.js");
// EXTERNAL MODULE: ./src/services/search/index.ts
var services_search = __webpack_require__("./src/services/search/index.ts");
// EXTERNAL MODULE: ./node_modules/debounce/index.js
var debounce = __webpack_require__("./node_modules/debounce/index.js");
// EXTERNAL MODULE: ./node_modules/@choc-ui/chakra-autocomplete/dist/chakra-autocomplete.esm.js + 3 modules
var chakra_autocomplete_esm = __webpack_require__("./node_modules/@choc-ui/chakra-autocomplete/dist/chakra-autocomplete.esm.js");
// EXTERNAL MODULE: ./src/store/store.ts + 9 modules
var store = __webpack_require__("./src/store/store.ts");
;// CONCATENATED MODULE: ./src/components/CreateWiki/EditorModals/EditWikiDetailsModal/LinkedWikisInput.tsx










const LinkedWikisInput = (param)=>{
    let { wiki  } = param;
    const dispatch = (0,hook/* useAppDispatch */.T)();
    const [search, setSearch] = react.useState("");
    const [results, setResults] = react.useState([]);
    const [loading, setLoading] = react.useState(false);
    const [selectedWiki, setSelectedWiki] = react.useState("");
    const [linkType, setLinkType] = react.useState();
    const fetchWikisList = async (query, cb, tag)=>{
        const { data  } = await store/* store.dispatch */.h.dispatch(services_search/* getWikisByTitle.initiate */.y9.initiate(query));
        const filteredData = data === null || data === void 0 ? void 0 : data.filter((w)=>w.tags.find((t)=>t.id.toLocaleLowerCase() === tag));
        cb(filteredData || []);
    };
    const debouncedFetchWikis = (0,debounce.debounce)((query, cb)=>{
        fetchWikisList(query, cb, linkType);
    }, 500);
    (0,react.useEffect)(()=>{
        if (search.length >= 3) {
            setLoading(true);
            debouncedFetchWikis(search, (data)=>{
                setResults(data.slice(0, 6));
                setLoading(false);
            });
        } else setResults([]);
        if (search !== "") setSelectedWiki("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search
    ]);
    const handleAddWiki = ()=>{
        if (selectedWiki === "") return;
        dispatch({
            type: "wiki/addLinkedWiki",
            payload: {
                linkType,
                wikiId: selectedWiki
            }
        });
        setSearch("");
        setSelectedWiki("");
    };
    const handleRemoveWiki = (wikiId, WikiLinkType)=>{
        store/* store.dispatch */.h.dispatch({
            type: "wiki/removeLinkedWiki",
            payload: {
                linkType: WikiLinkType,
                wikiId
            }
        });
    };
    const onlyLastTypeHasWikis = wiki.linkedWikis && Object.values(wiki.linkedWikis).filter((w)=>w.length > 0).length === 1 && Object.values(wiki.linkedWikis).reverse()[0].length > 0;
    const containsLinkedWikis = wiki.linkedWikis && Object.values(wiki.linkedWikis).some((wikis)=>wikis.length > 0);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
        rounded: "md",
        _dark: {
            borderColor: "whiteAlpha.300"
        },
        spacing: "2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                fontWeight: "semibold",
                children: "Link Wikis"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                borderColor: "gray.200",
                _dark: {
                    borderColor: "whiteAlpha.200"
                },
                gap: "2",
                gridTemplateColumns: {
                    base: "1fr 2fr",
                    md: "1.2fr 2fr 0.8fr"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(select_dist_index_esm/* Select */.Ph, {
                        value: linkType,
                        onChange: (e)=>setLinkType(e.target.value),
                        h: "40px",
                        rounded: "md",
                        flex: "5",
                        placeholder: "Select option",
                        children: Object.values(build_module/* LinkedWikiKey */.nF).map((key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.option */.m$.option, {
                                value: key,
                                children: key
                            }, key))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        flex: "8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_autocomplete_esm/* AutoComplete */.Qc, {
                            suggestWhenEmpty: true,
                            emptyState: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                    m: 5,
                                    fontSize: "xs",
                                    color: "linkColor",
                                    textAlign: "center",
                                    children: [
                                        "No results found. make sure the wiki you are searching for has",
                                        " ",
                                        "'",
                                        linkType,
                                        "' tag."
                                    ]
                                })
                            }),
                            onChange: (val)=>{
                                setSelectedWiki(val);
                                setSearch("");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_autocomplete_esm/* AutoCompleteInput */.Vp, {
                                    h: "40px",
                                    flex: "8",
                                    rounded: "md",
                                    disabled: !linkType,
                                    placeholder: "Search a wiki",
                                    value: (ref = search || selectedWiki) !== null && ref !== void 0 ? ref : "",
                                    onChange: (e)=>setSearch(e.target.value),
                                    type: "url"
                                }),
                                !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_autocomplete_esm/* AutoCompleteList */.Jm, {
                                    maxH: 32,
                                    mt: 0,
                                    overflowY: "auto",
                                    borderTopRadius: 0,
                                    p: 2,
                                    px: 0,
                                    children: results.map((result)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_autocomplete_esm/* AutoCompleteItem */.Gb, {
                                            px: 4,
                                            py: 1,
                                            rounded: "none",
                                            m: 0,
                                            fontSize: "xs",
                                            value: result,
                                            textTransform: "capitalize",
                                            children: result.title
                                        }, "option-".concat(result.id)))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                        isLoading: loading,
                        disabled: !linkType,
                        gridColumn: {
                            base: "span 2",
                            md: "unset"
                        },
                        h: "40px",
                        rounded: "md",
                        onClick: handleAddWiki,
                        children: "Add"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                borderWidth: containsLinkedWikis ? 1 : 0,
                p: containsLinkedWikis ? 2 : 0,
                borderRadius: "md",
                children: wiki.linkedWikis && Object.entries(wiki.linkedWikis).map((param, i)=>{
                    let [key, value] = param;
                    return value.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                        borderTopWidth: i !== 0 && !onlyLastTypeHasWikis ? 1 : 0,
                        paddingTop: i !== 0 && !onlyLastTypeHasWikis ? 2 : 0,
                        marginTop: i !== 0 && !onlyLastTypeHasWikis ? 2 : 0,
                        borderStyle: "dashed",
                        align: "start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                p: 0.3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        as: ri_index_esm/* RiArrowRightDownLine */.Ivt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: "sm",
                                        children: key
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Wrap */.Eq, {
                                children: value.map((wikiId)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Button */.zx, {
                                        display: "flex",
                                        gap: 2,
                                        bg: "gray.100",
                                        color: "black",
                                        _hover: {
                                            bg: "gray.100"
                                        },
                                        _dark: {
                                            color: "white",
                                            bg: "whiteAlpha.100"
                                        },
                                        rounded: "md",
                                        size: "xs",
                                        px: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontWeight: "normal",
                                                    fontSize: "xs",
                                                    children: wikiId
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                                boxSize: 4,
                                                fontSize: "xs",
                                                fontWeight: "bold",
                                                lineHeight: "none",
                                                color: "red.100",
                                                bg: "red.400",
                                                _hover: {
                                                    bg: "red.500"
                                                },
                                                rounded: "full",
                                                onClick: ()=>handleRemoveWiki(wikiId, key),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                    as: ri_index_esm/* RiCloseLine */.eSQ
                                                })
                                            })
                                        ]
                                    }, "".concat(wikiId, "-").concat(key)))
                            })
                        ]
                    }, key) : null;
                })
            })
        ]
    });
};
/* harmony default export */ var EditWikiDetailsModal_LinkedWikisInput = (LinkedWikisInput);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/textarea/dist/index.esm.js
var textarea_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/textarea/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__("./node_modules/react-icons/fi/index.esm.js");
;// CONCATENATED MODULE: ./src/components/CreateWiki/EditorModals/EditWikiDetailsModal/EventsInput/EventsList.tsx







const EventsList = (param)=>{
    let { handleFormChange  } = param;
    var ref, ref1, ref2;
    const wiki = (0,hook/* useAppSelector */.C)((state)=>state.wiki);
    const dispatch = (0,hook/* useAppDispatch */.T)();
    const [feedbackMessage, setFeedbackMessage] = (0,react.useState)("");
    const dateFoundedEvent = (ref = wiki.events) === null || ref === void 0 ? void 0 : ref.find((event)=>event.type === build_module/* EventType.CREATED */.tw.CREATED);
    const textFeedbackRef = (0,react.useRef)(null);
    const removeEventHandler = (date)=>{
        if (wiki.events && wiki.events.length > 1 && date === (dateFoundedEvent === null || dateFoundedEvent === void 0 ? void 0 : dateFoundedEvent.date)) {
            setFeedbackMessage("The Date Founded cannot be removed.");
            return;
        }
        setFeedbackMessage("");
        dispatch({
            type: "wiki/removeEvent",
            payload: {
                date
            }
        });
    };
    (0,react.useEffect)(()=>{
        if (feedbackMessage) {
            var ref;
            (ref = textFeedbackRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        feedbackMessage
    ]);
    if (!((ref1 = wiki.events) === null || ref1 === void 0 ? void 0 : ref1.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                border: "1px solid",
                borderRadius: "6px",
                py: "3",
                px: "2.5",
                gap: "2.5",
                flexWrap: "wrap",
                borderColor: "gray.200",
                _dark: {
                    borderColor: "whiteAlpha.200"
                },
                children: (ref2 = wiki.events) === null || ref2 === void 0 ? void 0 : ref2.map((wikiEvent)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        gap: "2",
                        alignItems: "center",
                        borderRadius: "md",
                        bg: "gray.200",
                        pl: "2",
                        _dark: {
                            bg: "whiteAlpha.200"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                alignItems: "center",
                                gap: "1",
                                flexShrink: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        as: fi_index_esm/* FiCalendar */.vlc,
                                        w: "16px",
                                        h: "16px"
                                    }),
                                    wikiEvent.type === build_module/* EventType.CREATED */.tw.CREATED && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontSize: "8px",
                                        color: "gray.800",
                                        pt: "1px",
                                        _dark: {
                                            color: "whiteAlpha.900"
                                        },
                                        children: "Created"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Button */.zx, {
                                onClick: ()=>{
                                    handleFormChange(wikiEvent);
                                },
                                w: "max-content",
                                display: "flex",
                                gap: 2,
                                bg: "gray.100",
                                color: "black",
                                _active: {
                                    bg: "gray.100"
                                },
                                _hover: {
                                    bg: "gray.100"
                                },
                                _dark: {
                                    color: "white",
                                    bg: "whiteAlpha.100"
                                },
                                borderLeftRadius: "0",
                                size: "xs",
                                px: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontWeight: "normal",
                                        fontSize: "xs",
                                        noOfLines: 1,
                                        display: "inline-block",
                                        overflowX: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        maxWidth: "150px",
                                        children: wikiEvent.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        flexShrink: 0,
                                        boxSize: 4,
                                        fontSize: "xs",
                                        fontWeight: "bold",
                                        lineHeight: "none",
                                        color: "red.100",
                                        bg: "red.400",
                                        _hover: {
                                            bg: "red.500"
                                        },
                                        rounded: "full",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            removeEventHandler(wikiEvent.date);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                            as: ri_index_esm/* RiCloseLine */.eSQ
                                        })
                                    })
                                ]
                            })
                        ]
                    }, wikiEvent.date))
            }),
            feedbackMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                ref: textFeedbackRef,
                color: "red.500",
                fontSize: "sm",
                mt: "2",
                children: feedbackMessage
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/CreateWiki/EditorModals/EditWikiDetailsModal/EventsInput/index.tsx







const validateForm = (date, title, link, description, type)=>{
    if (!date) return "Date is required";
    if (!title) return "Title is required";
    if (!description) return "Description is required";
    if (!type) return "Event type is required";
    if (new Date(date).toString() === "Invalid Date") return "The date entered is invalid date";
    if (!(0,textUtils/* isValidUrl */.jv)(link)) return "The link entered is invalid url";
    if (description.length > 255) return "Description should be less than 255 characters";
    if (title.length > 80) return "Title should be less than 80 characters";
    if (link.length > 500) return "Link should be less than 500 characters";
    return null;
};
const EventsInput = (param)=>{
    let { wiki  } = param;
    var ref, ref1;
    const dispatch = (0,hook/* useAppDispatch */.T)();
    const [errMsg, setErrMsg] = react.useState(null);
    const [isUpdate, setIsUpdate] = react.useState(false);
    const [inputTitle, setInputTitle] = (0,react.useState)(undefined);
    const formRef = react.useRef(null);
    const handleFormSubmit = (e)=>{
        var ref, ref1;
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const date = data.get("date");
        const title = data.get("title");
        const link = data.get("link");
        const description = data.get("description");
        const type = data.get("type");
        const error = validateForm(date, title, link, description, type);
        if (error) {
            setErrMsg(error);
            return;
        }
        dispatch({
            type: "wiki/addEvent",
            payload: {
                date,
                title,
                description,
                link,
                type
            }
        });
        (ref = formRef.current) === null || ref === void 0 ? void 0 : ref.reset();
        setIsUpdate(false);
        if (wiki.events && ((ref1 = wiki.events) === null || ref1 === void 0 ? void 0 : ref1.length) >= 1) {
            setInputTitle(undefined);
        }
    };
    const handleIsUpdateCheck = (date)=>{
        if (date) {
            var ref;
            const dateObj = new Date(date);
            const isExists = (ref = wiki.events) === null || ref === void 0 ? void 0 : ref.some((event)=>new Date(event.date).toISOString() === dateObj.toISOString());
            setIsUpdate(!!isExists);
        }
    };
    const handleFormChange = (data)=>{
        if (formRef.current) {
            const dateInput = formRef.current.elements.namedItem("date");
            const titleInput = formRef.current.elements.namedItem("title");
            const linkInput = formRef.current.elements.namedItem("link");
            const descriptionInput = formRef.current.elements.namedItem("description");
            const typeInput = formRef.current.elements.namedItem("type");
            dateInput.value = data.date;
            titleInput.value = data.title || "";
            linkInput.value = data.link || "";
            descriptionInput.value = data.description || "";
            typeInput.value = data.type;
            handleIsUpdateCheck(data.date);
        }
    };
    (0,react.useEffect)(()=>{
        if (!wiki.events || wiki.events.length === 1) {
            setInputTitle(undefined);
        }
    }, [
        wiki.events,
        (ref = wiki.events) === null || ref === void 0 ? void 0 : ref.length
    ]);
    const titleProps = ()=>{
        if (!wiki.events || wiki.events.length === 0) {
            var ref;
            if (((ref = wiki.categories[0]) === null || ref === void 0 ? void 0 : ref.id) === "people") {
                return {
                    value: "Date of birth"
                };
            }
            return {
                value: "Date Founded"
            };
        }
        return {
            value: inputTitle
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        fontWeight: "semibold",
                        children: "Event Dates"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        ref: formRef,
                        onChange: ()=>setErrMsg(null),
                        onSubmit: handleFormSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                flex: "8",
                                w: "full",
                                mt: "1.5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                                        gridTemplateColumns: {
                                            base: "1fr",
                                            md: "0.8fr 1fr 1fr"
                                        },
                                        gap: "3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                name: "date",
                                                type: "month",
                                                placeholder: "Select date",
                                                fontSize: {
                                                    base: "12px",
                                                    md: "14px"
                                                },
                                                onChange: (e)=>{
                                                    const date = e.target.value;
                                                    handleIsUpdateCheck(date);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                                name: "title",
                                                fontSize: {
                                                    base: "12px",
                                                    md: "14px"
                                                },
                                                type: "text",
                                                placeholder: "Title"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                                                name: "type",
                                                placeholder: "Event Type",
                                                fontSize: {
                                                    base: "12px",
                                                    md: "14px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: build_module/* EventType.CREATED */.tw.CREATED,
                                                        disabled: !isUpdate && (wiki === null || wiki === void 0 ? void 0 : (ref1 = wiki.events) === null || ref1 === void 0 ? void 0 : ref1.some((event)=>event.type === build_module/* EventType.CREATED */.tw.CREATED)),
                                                        children: titleProps().value || "Created"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: build_module/* EventType.DEFAULT */.tw.DEFAULT,
                                                        children: "Default"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                                        mt: "3",
                                        name: "link",
                                        type: "url",
                                        placeholder: "Link",
                                        fontSize: {
                                            base: "12px",
                                            md: "14px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
                                gridTemplateColumns: {
                                    base: "1fr",
                                    md: "2fr 110px"
                                },
                                gap: "3",
                                mt: "3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, {
                                        name: "description",
                                        placeholder: "Write a short description for the event date",
                                        h: {
                                            base: "80px",
                                            md: "initial"
                                        },
                                        fontSize: {
                                            base: "12px",
                                            md: "14px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                                        type: "submit",
                                        w: "full",
                                        rounded: "md",
                                        h: "40px",
                                        children: isUpdate ? "Update" : "Add "
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            errMsg && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                color: "red.500",
                fontSize: "sm",
                mt: "2",
                children: errMsg
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsList, {
                handleFormChange: handleFormChange
            })
        ]
    });
};
/* harmony default export */ var EditWikiDetailsModal_EventsInput = (EventsInput);

;// CONCATENATED MODULE: ./src/components/CreateWiki/EditorModals/EditWikiDetailsModal/index.tsx









const HighlightsModal = (param)=>{
    let { onClose =()=>{} , isOpen =false , ...rest } = param;
    const currentWiki = (0,hook/* useAppSelector */.C)((state)=>state.wiki);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        onClose: onClose,
        isOpen: isOpen,
        isCentered: true,
        size: "2xl",
        ...rest,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                w: "min(95vw, 600px)",
                _dark: {
                    bg: "gray.800"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalHeader */.xB, {
                        fontSize: "lg",
                        display: "flex",
                        alignItems: "center",
                        children: [
                            "Edit Details",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {
                                size: "sm",
                                my: "auto",
                                position: "unset",
                                ml: "auto"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                            borderTopWidth: 1,
                            borderBottomWidth: 1,
                            spacing: "4",
                            mx: -6,
                            mt: -2,
                            py: 4,
                            px: 6,
                            maxH: "min(64vh, 500px)",
                            overflowY: "auto",
                            zIndex: "4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditWikiDetailsModal_CategoryInput, {
                                    wiki: currentWiki
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditWikiDetailsModal_TagsInput, {
                                    wiki: currentWiki
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditWikiDetailsModal_LinkedWikisInput, {
                                    wiki: currentWiki
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditWikiDetailsModal_LinksInput, {
                                    wiki: currentWiki
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EditWikiDetailsModal_EventsInput, {
                                    wiki: currentWiki
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalFooter */.mz, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                            colorScheme: "blue",
                            mx: "auto",
                            w: {
                                base: "full",
                                md: "initial"
                            },
                            onClick: onClose,
                            children: "Close"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var EditWikiDetailsModal = (HighlightsModal);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/progress/dist/index.esm.js
var progress_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/progress/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__("./node_modules/uuid/dist/esm-browser/v4.js");
// EXTERNAL MODULE: ./src/components/WikiImage.tsx
var WikiImage = __webpack_require__("./src/components/WikiImage.tsx");
// EXTERNAL MODULE: ./src/utils/DataTransform/mediaUtils.tsx
var mediaUtils = __webpack_require__("./src/utils/DataTransform/mediaUtils.tsx");
;// CONCATENATED MODULE: ./src/components/CreateWiki/EditorModals/MediaModal.tsx













const MAX_MEDIA = 12;
const MediaModal = (param)=>{
    let { onClose =()=>{} , isOpen =false , ...rest } = param;
    var ref, ref1;
    const wiki = (0,hook/* useAppSelector */.C)((state)=>state.wiki);
    const dispatch = (0,hook/* useAppDispatch */.T)();
    const toast = (0,toast_dist_index_esm/* useToast */.pm)();
    const uploadImageToIPFS = async (image)=>{
        const ipfsHash = await (0,saveImage/* saveImage */.D)(image);
        if (ipfsHash) {
            dispatch({
                type: "wiki/updateMediaDetails",
                payload: {
                    hash: ipfsHash,
                    id: image.id
                }
            });
        }
    };
    const deleteMedia = (mediaId)=>{
        dispatch({
            type: "wiki/removeMedia",
            payload: {
                id: mediaId
            }
        });
    };
    const handleSetImage = (name, value)=>{
        var ref;
        if (wiki.media !== undefined && ((ref = wiki.media) === null || ref === void 0 ? void 0 : ref.length) >= MAX_MEDIA) {
            toast({
                title: "You cannot upload more than ".concat(MAX_MEDIA, " media. You can delete some existing media to create more spaces"),
                status: "error",
                duration: 3000
            });
            return;
        }
        const id = "".concat((0,v4/* default */.Z)(), "_").concat(Constants/* MEDIA_POST_DEFAULT_ID */.ft);
        const fileSize = value.byteLength / 1024 ** 2;
        if (fileSize > 10) {
            toast({
                title: "File size is larger than 8mb",
                status: "error",
                duration: 3000
            });
            return;
        }
        dispatch({
            type: "wiki/addMedia",
            payload: {
                name,
                size: (0,textUtils/* shortenBalance */.lK)(fileSize),
                id,
                type: build_module/* MediaType.GALLERY */.DD.GALLERY,
                source: "IPFS_IMG"
            }
        });
        uploadImageToIPFS({
            id,
            type: value
        });
    };
    const handleSetType = (mediaId, type)=>{
        dispatch({
            type: "wiki/updateMediaDetails",
            payload: {
                id: mediaId,
                hash: mediaId,
                type
            }
        });
    };
    const dropZoneActions = {
        setImage: handleSetImage,
        showFetchedImage: false,
        textType: "image"
    };
    return isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        onClose: onClose,
        isOpen: isOpen,
        isCentered: true,
        size: "xl",
        ...rest,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalContent */.hz, {
                w: "min(95vw, 600px)",
                _dark: {
                    bg: "gray.800"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalHeader */.xB, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                            align: "start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "lg",
                                    fontWeight: "bold",
                                    children: "Add Image or Video to Media Gallery"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "sm",
                                    fontWeight: "normal",
                                    children: "Adding media makes an article more interactive and engaging. You can upload jpg, gif and png files or link to youtube videos."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            mt: "3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontWeight: "bold",
                                    children: "Uploads"
                                }),
                                wiki.media !== undefined && ((ref = wiki.media) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                                    mt: 4,
                                    maxH: "240px",
                                    borderWidth: "1px",
                                    p: 3,
                                    borderRadius: 8,
                                    overflowY: "scroll",
                                    columns: {
                                        base: 1,
                                        md: 2
                                    },
                                    spacing: 4,
                                    children: wiki.media.map((media)=>{
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                            gap: 4,
                                            w: "100%",
                                            alignItems: "center",
                                            color: "linkColor",
                                            children: [
                                                !(0,mediaUtils/* checkMediaDefaultId */.W)(media.id) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiImage/* WikiImage */.R, {
                                                    cursor: "pointer",
                                                    alt: "media",
                                                    flexShrink: 0,
                                                    imageURL: media.source !== "YOUTUBE" ? (0,mediaUtils/* constructMediaUrl */.w)(media) : "https://i3.ytimg.com/vi/".concat(media.name, "/maxresdefault.jpg"),
                                                    boxSize: "42",
                                                    borderRadius: "lg",
                                                    overflow: "hidden",
                                                    mt: "1"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiImageLine */.PBv, {
                                                    size: "42"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                                                    spacing: 1,
                                                    w: "full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                                            w: "full",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                    fontSize: "sm",
                                                                    flex: "1",
                                                                    children: media.name ? (0,textUtils/* shortenText */.El)(media.name, 15) : "untitled"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                                                    mt: 1,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiCloseLine */.eSQ, {
                                                                        cursor: "pointer",
                                                                        onClick: ()=>deleteMedia(media.id),
                                                                        color: "red",
                                                                        size: "14"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        (0,mediaUtils/* checkMediaDefaultId */.W)(media.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_dist_index_esm/* Progress */.Ex, {
                                                            w: "full",
                                                            h: "3px",
                                                            colorScheme: "green",
                                                            size: "sm",
                                                            isIndeterminate: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                                            w: "full",
                                                            fontSize: "xs",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                                                                    size: "xs",
                                                                    maxW: "28",
                                                                    variant: "outline",
                                                                    value: media.type,
                                                                    onChange: (e)=>handleSetType(media.id, e.target.value),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: build_module/* MediaType.GALLERY */.DD.GALLERY,
                                                                            children: "Default"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            disabled: ((ref = wiki.media) === null || ref === void 0 ? void 0 : ref.find((m)=>m.type === build_module/* MediaType.ICON */.DD.ICON)) !== undefined,
                                                                            value: build_module/* MediaType.ICON */.DD.ICON,
                                                                            children: "Token Icon"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                                                    textAlign: "right",
                                                                    flex: "1",
                                                                    children: [
                                                                        media.size,
                                                                        "mb"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, media.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                    direction: "column",
                                    gap: 5,
                                    w: "full",
                                    borderRadius: "7px",
                                    py: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Dropzone */.fh, {
                                            dropZoneActions: dropZoneActions,
                                            dropzonePlaceHolderTitle: "Drag and drop an ".concat(dropZoneActions.textType, " or click to select."),
                                            dropzonePlaceHolderSize: "(10mb max)",
                                            aspectRatio: 11 / 3,
                                            mediaModal: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* ImageInput */.aG, {
                                            setImage: handleSetImage,
                                            showFetchedImage: false,
                                            modalUpload: true
                                        })
                                    ]
                                }),
                                wiki.media !== undefined && ((ref1 = wiki.media) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                    mb: 4,
                                    justifyContent: "center",
                                    display: "flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                                        spacing: 4,
                                        direction: "row",
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                                                size: "md",
                                                onClick: onClose,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontSize: "xs",
                                                    children: "Save"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                                                onClick: onClose,
                                                variant: "outline",
                                                size: "md",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                    fontSize: "xs",
                                                    children: "Cancel"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }) : null;
};
/* harmony default export */ var EditorModals_MediaModal = (MediaModal);

// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__("./src/utils/googleAnalytics.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tag/dist/index.esm.js
var tag_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tag/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("./node_modules/axios/index.js");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__("./node_modules/react-i18next/dist/es/useTranslation.js");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
;// CONCATENATED MODULE: ./src/abi/EditorAbi.ts
const EditorABI = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "EditorNotWhitelisted",
        type: "error"
    },
    {
        inputs: [],
        name: "WrongIPFSLength",
        type: "error"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "editorAddress",
                type: "address"
            }
        ],
        name: "isEditorWhitelisted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address"
            }
        ],
        name: "setOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "editorAddress",
                type: "address"
            }
        ],
        name: "unWhitelistEditor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_user",
                type: "address"
            },
            {
                internalType: "string",
                name: "_ipfs",
                type: "string"
            }
        ],
        name: "validate",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "editorAddress",
                type: "address"
            }
        ],
        name: "whitelistEditor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];

// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__("./src/config/index.ts");
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__("./node_modules/wagmi/dist/index.js");
;// CONCATENATED MODULE: ./src/hooks/useWhiteListValidator.ts



const useWhiteListValidator = (address)=>{
    const { data: isEditorWhiteListed  } = (0,dist/* useContractRead */["do"])({
        address: config/* default.editorAddress */.Z.editorAddress,
        abi: EditorABI,
        functionName: "isEditorWhitelisted",
        args: [
            address
        ]
    });
    return {
        userCanEdit: config/* default.isProduction */.Z.isProduction === "true" ? isEditorWhiteListed : true
    };
};
/* harmony default export */ var hooks_useWhiteListValidator = ((/* unused pure expression or super */ null && (useWhiteListValidator)));

// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js
var tooltip_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tooltip/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/CreateWiki/WikiDetailsSidebar/AIGenerateButton.tsx






const AIGenerateButton = (param)=>{
    let { isGenerating , handleAIGenerate  } = param;
    const [isDisabled, setIsDisabled] = react.useState(false);
    const [timeLeft, setTimeLeft] = react.useState(0);
    const { address: userAddress  } = (0,dist/* useAccount */.mA)();
    const { userCanEdit  } = useWhiteListValidator(userAddress);
    react.useEffect(()=>{
        const timeCounter = setInterval(()=>{
            const lastTime = localStorage.getItem("AI_SUMMARY_GENERATE_RATE_LIMITED");
            if (lastTime) {
                const [lastTimeDate, now] = [
                    new Date(lastTime),
                    new Date()
                ];
                if (now.getTime() - lastTimeDate.getTime() > Constants/* WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL */.hj) {
                    setIsDisabled(false);
                    localStorage.removeItem("AI_SUMMARY_GENERATE_RATE_LIMITED");
                    setTimeLeft(0);
                } else {
                    const currentTimeLeft = Math.ceil((Constants/* WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL */.hj - (now.getTime() - lastTimeDate.getTime())) / 1000);
                    setIsDisabled(true);
                    setTimeLeft(currentTimeLeft);
                }
            }
        }, 1000);
        return ()=>clearInterval(timeCounter);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
        hasArrow: true,
        mr: 5,
        maxW: "180px",
        textAlign: "center",
        isDisabled: !isDisabled,
        label: "Rate limit exceeded. wait for ".concat(timeLeft, " seconds."),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
            size: "xs",
            px: 2,
            fontSize: "xs",
            disabled: isGenerating || isDisabled || !userCanEdit,
            sx: {
                _disabled: {
                    backgroundColor: isDisabled ? "gray.600 !important" : "brand.500 !important",
                    color: isDisabled ? "gray.400 !important" : "white !important"
                }
            },
            isLoading: isGenerating,
            onClick: handleAIGenerate,
            children: "AI Generate"
        })
    });
};
/* harmony default export */ var WikiDetailsSidebar_AIGenerateButton = (AIGenerateButton);

;// CONCATENATED MODULE: ./src/components/CreateWiki/WikiDetailsSidebar/SummaryInput.tsx










const sleep = (ms)=>new Promise((r)=>{
        setTimeout(r, ms);
    });
const SummaryInput = ()=>{
    var ref;
    const wiki = (0,hook/* useAppSelector */.C)((state)=>state.wiki);
    const [showRed, setShowRed] = react.useState(false);
    const dispatch = (0,hook/* useAppDispatch */.T)();
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    const [isGenerating, setIsGenerating] = react.useState(false);
    const [reserveSummaries, setReserveSummaries] = react.useState([]);
    const toast = (0,toast_dist_index_esm/* useToast */.pm)();
    const failedToGenerateSummary = (0,react.useCallback)(()=>{
        setShowRed(true);
        setTimeout(()=>setShowRed(false), 3000);
        toast({
            title: "Error generating summary.",
            description: "Please try again later.",
            status: "error"
        });
        (0,googleAnalytics/* logEvent */.K)({
            action: "GENERATE_SUMMARY",
            label: wiki.id,
            category: "summary-generate",
            value: 0
        });
    }, [
        toast,
        wiki.id
    ]);
    const rateLimitReached = ()=>{
        localStorage.setItem("AI_SUMMARY_GENERATE_RATE_LIMITED", new Date().toISOString());
    };
    const fetchFromReserveSummary = (0,react.useCallback)(async ()=>{
        const summary = reserveSummaries[0];
        await sleep(3000) // Makes it look like it's generating :D
        ;
        if (summary) {
            dispatch({
                type: "wiki/setCurrentWiki",
                payload: {
                    summary
                }
            });
        }
        setIsGenerating(false);
        setReserveSummaries((r)=>r.slice(1));
    }, [
        dispatch,
        reserveSummaries
    ]);
    const handleAIGenerate = (0,react.useCallback)(async ()=>{
        setIsGenerating(true);
        if (reserveSummaries.length > 0) {
            fetchFromReserveSummary();
            return;
        }
        try {
            const { data , headers  } = await axios_default().post("/api/summary-generate", {
                title: wiki.title,
                content: wiki.content,
                isAboutPerson: !!wiki.categories.find((i)=>i.id === "person")
            });
            if (headers["x-ratelimit-remaining"] === "1") rateLimitReached();
            dispatch({
                type: "wiki/setCurrentWiki",
                payload: {
                    summary: data[0]
                }
            });
            if (data.length > 1) setReserveSummaries(data.slice(1));
            (0,googleAnalytics/* logEvent */.K)({
                action: "GENERATE_SUMMARY",
                label: wiki.id,
                category: "summary-generate",
                value: 1
            });
        } catch (error) {
            const { response  } = error;
            if ((response === null || response === void 0 ? void 0 : response.status) === 429) rateLimitReached();
            else failedToGenerateSummary();
        }
        setIsGenerating(false);
    }, [
        dispatch,
        failedToGenerateSummary,
        fetchFromReserveSummary,
        reserveSummaries.length,
        wiki.categories,
        wiki.content,
        wiki.id,
        wiki.title
    ]);
    const summaryLimitTagColor = ()=>{
        var ref;
        if (showRed) {
            return "red";
        }
        if (((wiki === null || wiki === void 0 ? void 0 : (ref = wiki.summary) === null || ref === void 0 ? void 0 : ref.length) || 0) > Constants/* WIKI_SUMMARY_LIMIT */.a * 2 / 3) return "green";
        return "yellow";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                mb: 2,
                justify: "space-between",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        color: "wikiSummaryLabel",
                        children: "".concat(t("wikiSummaryLabel"))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(tag_dist_index_esm/* Tag */.Vp, {
                                variant: "solid",
                                colorScheme: summaryLimitTagColor(),
                                children: [
                                    (wiki === null || wiki === void 0 ? void 0 : (ref = wiki.summary) === null || ref === void 0 ? void 0 : ref.length) || 0,
                                    "/",
                                    Constants/* WIKI_SUMMARY_LIMIT */.a
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiDetailsSidebar_AIGenerateButton, {
                                handleAIGenerate: handleAIGenerate,
                                isGenerating: isGenerating
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                position: "relative",
                h: "85px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, {
                        disabled: isGenerating,
                        fontSize: "sm",
                        bgColor: showRed ? "#d406082a" : "transparent",
                        color: "wikiSummaryInputText",
                        _focus: {
                            borderColor: showRed ? "#ff787c" : "#63b3ed",
                            boxShadow: showRed ? "0 0 0 1px #ff787c" : "0 0 0 1px #63b3ed"
                        },
                        h: "100%",
                        value: wiki.summary,
                        onChange: (event)=>{
                            if (event.target.value.length <= Constants/* WIKI_SUMMARY_LIMIT */.a) dispatch({
                                type: "wiki/setCurrentWiki",
                                payload: {
                                    summary: event.target.value
                                }
                            });
                            else {
                                setShowRed(true);
                                setTimeout(()=>setShowRed(false), 2000);
                            }
                        },
                        placeholder: "".concat(t("wikiSummaryPlaceholder"))
                    }),
                    isGenerating && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        alt: "loading animation - robot flying",
                        src: "/images/backgrounds/robot.gif",
                        position: "absolute",
                        top: "-100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "100px",
                        height: "100px"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var WikiDetailsSidebar_SummaryInput = (SummaryInput);

;// CONCATENATED MODULE: ./src/components/CreateWiki/WikiDetailsSidebar/index.tsx










const WikiDetailsSidebar = (param)=>{
    let { initialImage , isToResetImage  } = param;
    const { isOpen , onOpen , onClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const { isOpen: isMediaOpen , onOpen: mediaOpen , onClose: mediaClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const toast = (0,toast_dist_index_esm/* useToast */.pm)();
    const [hideDropzone, setHideDropzone] = (0,react.useState)(false);
    const [hideImageInput, setHideImageInput] = (0,react.useState)(false);
    const [wikiImageUploading, setWikiImageUploading] = (0,react.useState)(false);
    const handleSetImage = async (_, value)=>{
        setWikiImageUploading(true);
        const IPFSHash = await (0,saveImage/* saveImage */.D)({
            type: value,
            id: ""
        });
        setWikiImageUploading(false);
        if (IPFSHash) {
            dispatch({
                type: "wiki/addWikiImageIPFS",
                payload: IPFSHash
            });
        } else {
            toast({
                title: "Error uploading image",
                status: "error"
            });
        }
    };
    const handleDeleteImage = ()=>dispatch({
            type: "wiki/deleteWikiImages"
        });
    const dropZoneActions = {
        setImage: handleSetImage,
        setHideImageInput,
        isToResetImage,
        deleteImage: handleDeleteImage,
        initialImage,
        showFetchedImage: true,
        textType: "main image"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        direction: "column",
        gap: 4,
        w: {
            base: "full",
            xl: "400px"
        },
        border: "1px",
        borderColor: "borderColor",
        borderRadius: "7px",
        padding: "15px",
        h: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiDetailsSidebar_SummaryInput, {}),
            !hideDropzone && /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Dropzone */.fh, {
                imageUploading: wikiImageUploading,
                dropZoneActions: dropZoneActions
            }),
            !hideImageInput && /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* ImageInput */.aG, {
                imageUploading: wikiImageUploading,
                setImage: handleSetImage,
                setHideDropzone: setHideDropzone,
                deleteImage: handleDeleteImage,
                showFetchedImage: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                borderWidth: "1px",
                justify: "space-between",
                gap: 2,
                p: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        ml: 2,
                        gap: 2,
                        color: "linkColor",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                mt: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiFilmLine */.v39, {
                                    size: "16"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                children: "Media"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                        maxW: "190px",
                        onClick: mediaOpen,
                        px: 3,
                        size: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: "sm",
                            children: "Add images/videos"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                direction: "column",
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                    w: "full",
                    direction: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                        w: "full",
                        variant: "outline",
                        color: "linkColor",
                        onClick: onOpen,
                        children: "Edit Wiki Details"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditWikiDetailsModal, {
                isOpen: isOpen,
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorModals_MediaModal, {
                isOpen: isMediaOpen,
                onClose: mediaClose
            })
        ]
    });
};
/* harmony default export */ var CreateWiki_WikiDetailsSidebar = (/*#__PURE__*/(0,react.memo)(WikiDetailsSidebar));

// EXTERNAL MODULE: ./src/store/slices/wiki.slice.ts
var wiki_slice = __webpack_require__("./src/store/slices/wiki.slice.ts");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
;// CONCATENATED MODULE: ./src/components/SEO/CreateWikiPage.tsx



const CreateWikiPageHeader = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: "Create wiki",
        description: "Create a new wiki",
        canonical: "https://iq.wiki/create-wiki",
        openGraph: {
            title: "Create wiki page",
            description: "Create a new wiki"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWIKI",
            site: "IQWiki"
        }
    });
/* harmony default export */ var CreateWikiPage = (CreateWikiPageHeader);

// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiFields.ts
var getWikiFields = __webpack_require__("./src/utils/WikiUtils/getWikiFields.ts");
// EXTERNAL MODULE: ./src/services/activities/index.ts + 1 modules
var activities = __webpack_require__("./src/services/activities/index.ts");
// EXTERNAL MODULE: ./src/services/wikis/index.ts
var wikis = __webpack_require__("./src/services/wikis/index.ts");
;// CONCATENATED MODULE: ./src/utils/CreateWikiUtils/createWikiMessages.ts

const initialEditorValue = " ";
const initialMsg = "Your Wiki is being processed and will be available within 5 minutes depending on blockchain congestion";
const defaultErrorMessage = "Oops, An Error Occurred. Wiki could not be created";
const successMessage = "Wiki has been created successfully.";
const editedMessage = "Wiki has been updated successfully";
const ValidationErrorMessage = (type)=>{
    switch(type){
        case build_module/* ValidatorCodes.CATEGORY */.ii.CATEGORY:
            return "Category must be a valid category name.";
        case build_module/* ValidatorCodes.LANGUAGE */.ii.LANGUAGE:
            return "Language linked to wiki must be a valid language name.";
        case build_module/* ValidatorCodes.USER */.ii.USER:
            return "Transaction is not signed by the user.";
        case build_module/* ValidatorCodes.WORDS */.ii.WORDS:
            return "Wiki must have at least 100 words.";
        case build_module/* ValidatorCodes.IMAGE */.ii.IMAGE:
            return "Images must be no more than 5 and no less than 1.";
        case build_module/* ValidatorCodes.TAG */.ii.TAG:
            return "Tags must be no more than 5";
        case build_module/* ValidatorCodes.URL */.ii.URL:
            return "No External URL are allowed.";
        case build_module/* ValidatorCodes.METADATA */.ii.METADATA:
            return "Wiki metadata is incorrect. Please check the wiki.";
        case build_module/* ValidatorCodes.SUMMARY */.ii.SUMMARY:
            return "Summary must be no more than 128 characters.";
        case build_module/* ValidatorCodes.ID_ERROR */.ii.ID_ERROR:
            return "ID is incorrect. Please check the wiki.";
        case build_module/* ValidatorCodes.MEDIA */.ii.MEDIA:
            return "Invalid media data. Please check the media attached to wiki.";
        case build_module/* ValidatorCodes.GLOBAL_RATE_LIMIT */.ii.GLOBAL_RATE_LIMIT:
            return "You have reached the rate limit. Please try again later";
        default:
            return "An error occurred.";
    }
};

// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/query/rtk-query.cjs.production.min.js
var rtk_query_cjs_production_min = __webpack_require__("./node_modules/@reduxjs/toolkit/dist/query/rtk-query.cjs.production.min.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-utils/dist/chakra-ui-react-utils.esm.js
var chakra_ui_react_utils_esm = __webpack_require__("./node_modules/@chakra-ui/react-utils/dist/chakra-ui-react-utils.esm.js");
;// CONCATENATED MODULE: ./src/hooks/useCreateWikiState.ts








const [CreateWikiProvider, useCreateWikiContext] = (0,chakra_ui_react_utils_esm/* createContext */.kr)();
const useCreateWikiState = (router)=>{
    const { slug , revision  } = router.query;
    const { isLoading: isLoadingLatestWiki , data: latestWikiData  } = (0,wikis/* useGetWikiQuery */.HL)(typeof revision !== "string" && typeof slug === "string" ? slug : rtk_query_cjs_production_min.skipToken);
    const { isLoading: isLoadingRevisionWiki , data: revisionWikiData  } = (0,activities/* useGetWikiByActivityIdQuery */.F)(typeof revision === "string" ? revision : rtk_query_cjs_production_min.skipToken);
    const isLoadingWiki = isLoadingLatestWiki || isLoadingRevisionWiki;
    const wikiData = (0,react.useMemo)(()=>{
        const data = revisionWikiData || latestWikiData;
        if (data === null || data === void 0 ? void 0 : data.linkedWikis) {
            // remove null values from linked wikis
            const newLinkedWikis = {};
            Object.entries(data.linkedWikis).forEach((param)=>{
                let [key, value] = param;
                if (value !== null) {
                    newLinkedWikis[key] = value;
                }
            });
            return {
                ...data,
                linkedWikis: newLinkedWikis
            };
        }
        return data;
    }, [
        latestWikiData,
        revisionWikiData
    ]);
    const [commitMessage, setCommitMessage] = (0,react.useState)("");
    const [isWritingCommitMsg, setIsWritingCommitMsg] = (0,react.useState)(false);
    const [txHash, setTxHash] = (0,react.useState)();
    const [submittingWiki, setSubmittingWiki] = (0,react.useState)(false);
    const [wikiHash, setWikiHash] = (0,react.useState)();
    const [isNewCreateWiki, setIsNewCreateWiki] = (0,react.useState)(false);
    const toast = (0,toast_dist_index_esm/* useToast */.pm)();
    const [openOverrideExistingWikiDialog, setOpenOverrideExistingWikiDialog] = (0,react.useState)(false);
    const [existingWikiData, setExistingWikiData] = (0,react.useState)();
    const [activeStep, setActiveStep] = (0,react.useState)(0);
    const [loadingState, setIsLoading] = (0,react.useState)("loading");
    const [wikiId, setWikiId] = (0,react.useState)("");
    const [msg, setMsg] = (0,react.useState)(initialMsg);
    const [txError, setTxError] = (0,react.useState)({
        title: "",
        description: "",
        opened: false
    });
    const dispatch = (0,hook/* useAppDispatch */.T)();
    return {
        isLoadingWiki,
        wikiData,
        commitMessage,
        setCommitMessage,
        dispatch,
        slug,
        revision,
        toast,
        isWritingCommitMsg,
        setIsWritingCommitMsg,
        txHash,
        setTxHash,
        submittingWiki,
        setSubmittingWiki,
        wikiHash,
        setWikiHash,
        isNewCreateWiki,
        setIsNewCreateWiki,
        openOverrideExistingWikiDialog,
        setOpenOverrideExistingWikiDialog,
        existingWikiData,
        setExistingWikiData,
        activeStep,
        setActiveStep,
        loadingState,
        setIsLoading,
        wikiId,
        setWikiId,
        msg,
        setMsg,
        txError,
        setTxError
    };
};

;// CONCATENATED MODULE: ./src/hooks/useCreateWikiEffects.ts





const useCreateWikiEffects = ()=>{
    const { slug , revision , setIsNewCreateWiki , dispatch  } = useCreateWikiContext();
    // Reset the State to new wiki if there is no slug
    (0,react.useEffect)(()=>{
        if (!slug && !revision) {
            setIsNewCreateWiki(true);
            // fetch draft data from local storage
            const draft = (0,wiki_slice/* getDraftFromLocalStorage */.ON)();
            if (draft) {
                dispatch({
                    type: "wiki/setInitialWikiState",
                    payload: {
                        ...draft,
                        content: build_module/* EditorContentOverride */.yh + draft.content.replace(/ {2}\n/gm, "\n")
                    }
                });
            } else {
                dispatch({
                    type: "wiki/reset"
                });
                dispatch({
                    type: "wiki/setInitialWikiState",
                    payload: {
                        content: build_module/* EditorContentOverride */.yh + initialEditorValue
                    }
                });
            }
        } else {
            setIsNewCreateWiki(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        slug
    ]);
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/alert/dist/index.esm.js
var alert_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/alert/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/close-button/dist/index.esm.js
var close_button_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/close-button/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/CreateWiki/TxError.tsx



const TxErrorAlert = (param)=>{
    let { txError , setTxError  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        children: txError.opened && /*#__PURE__*/ (0,jsx_runtime.jsxs)(alert_dist_index_esm/* Alert */.bZ, {
            status: "error",
            maxW: "md",
            mb: "3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dist_index_esm/* AlertIcon */.zM, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dist_index_esm/* AlertTitle */.Cd, {
                    children: txError.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_dist_index_esm/* AlertDescription */.X, {
                    children: txError.description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button_dist_index_esm/* CloseButton */.P, {
                    onClick: ()=>setTxError({
                            title: "",
                            description: "",
                            opened: false
                        }),
                    position: "absolute",
                    right: "5px"
                })
            ]
        })
    });
};
/* harmony default export */ var TxError = (TxErrorAlert);

// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__("./node_modules/react-icons/md/index.esm.js");
;// CONCATENATED MODULE: ./src/components/CreateWiki/CreateWikiTopBar/WikiTitleInput.tsx







const WikiTitleInput = ()=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const title = (0,hook/* useAppSelector */.C)((state)=>state.wiki.title);
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(input_dist_index_esm/* InputGroup */.BZ, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* InputLeftElement */.Z8, {
                pointerEvents: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                    as: md_index_esm/* MdTitle */.SQS,
                    color: "gray.400",
                    fontSize: "25px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                fontWeight: "500",
                color: "wikiTitleInputText",
                borderColor: "transparent",
                fontSize: "18px",
                variant: "flushed",
                maxW: "max(50%, 300px)",
                onChange: (event)=>{
                    dispatch({
                        type: "wiki/setCurrentWiki",
                        payload: {
                            title: event.target.value
                        }
                    });
                },
                value: title,
                placeholder: "".concat(t("wikiTitlePlaceholder")),
                _placeholder: {
                    color: "wikiTitleInputText"
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/popover/dist/index.esm.js + 1 modules
var popover_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/popover/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/CreateWiki/CreateWikiTopBar/WikiScoreIndicator.tsx






const WikiScoreIndicator = ()=>{
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const wiki = (0,hook/* useAppSelector */.C)((state)=>state.wiki);
    const score = (0,build_module/* calculateWikiScore */["in"])(wiki);
    if (!score) return null;
    let color = "green.400";
    if (score < 30) {
        color = "red.400";
    } else if (score < 50) {
        color = "orange.400";
    } else if (score < 70) {
        color = "yellow.400";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* Popover */.J2, {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        returnFocusOnClose: false,
        "aria-label": "Wiki preview",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverTrigger */.xo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_dist_index_esm/* CircularProgress */.D8, {
                        cursor: "help",
                        onMouseOver: ()=>setIsOpen(true),
                        onMouseOut: ()=>setIsOpen(false),
                        onFocus: ()=>{},
                        onBlur: ()=>{},
                        size: "35px",
                        value: score,
                        color: color,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_dist_index_esm/* CircularProgressLabel */.ip, {
                            fontSize: "xs",
                            children: score
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* PopoverContent */.yk, {
                boxShadow: "rgb(4 17 29 / 25%) 0px 0px 8px 0px",
                _focus: {
                    outline: "none"
                },
                mx: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverArrow */.QH, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* PopoverBody */.b, {
                        onMouseOver: ()=>setIsOpen(true),
                        onMouseOut: ()=>setIsOpen(false),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                my: 1,
                                fontWeight: "500",
                                fontSize: "sm",
                                children: "Wiki Score"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                fontSize: "xs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(system_dist_index_esm/* chakra.span */.m$.span, {
                                        opacity: 0.7,
                                        children: [
                                            "This measures the quality of your wiki which is based on several determining factors such as number of words, citations, tags, metalinks etc.",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        color: "brandLinkColor",
                                        href: "/faq",
                                        children: "learn more"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CreateWikiTopBar_WikiScoreIndicator = (WikiScoreIndicator);

;// CONCATENATED MODULE: ./src/utils/DataTransform/getWordCount.ts
const getWordCount = (str)=>str.split(" ").filter((n)=>n !== "").length;

;// CONCATENATED MODULE: ./src/utils/CreateWikiUtils/isValidWiki.ts



const MINIMUM_WORDS = 100;
const checkErrors = (toast, conditionErrorPair)=>{
    let isErrorFree = true;
    conditionErrorPair.forEach((param)=>{
        let [errorText, condition] = param;
        if (isErrorFree && condition()) {
            toast({
                title: errorText,
                status: "error",
                duration: 3000
            });
            isErrorFree = false;
        }
    });
    return isErrorFree;
};
const isMediaUploading = (wiki)=>{
    var ref;
    return !((ref = wiki.media) === null || ref === void 0 ? void 0 : ref.every((m)=>!m.id.endsWith(Constants/* MEDIA_POST_DEFAULT_ID */.ft)));
};
const isSummaryExceedsLimit = (wiki)=>!!(wiki.summary && wiki.summary.length > Constants/* WIKI_SUMMARY_LIMIT */.a);
const isCitationInvalid = (wiki)=>{
    var ref, ref1;
    return ((ref = wiki.metadata.find((meta)=>meta.id === "references")) === null || ref === void 0 ? void 0 : ref.value.length) === 0 || !wiki.metadata.find((meta)=>meta.id === "references") || !((ref1 = wiki.metadata.find((meta)=>meta.id === "references")) === null || ref1 === void 0 ? void 0 : ref1.value);
};
const NO_WIKI_TITLE_ERROR = "Add a Title at the top for this Wiki to continue";
const TITLE_EXCEEDS_LIMIT_ERROR = "Title should be less than 60 characters";
const NO_WIKI_CONTENT_ERROR = "Add a Content section to continue";
const SUMMARY_EXCEEDS_LIMIT_ERROR = "Summary exceeds maximum limit of ".concat(Constants/* WIKI_SUMMARY_LIMIT */.a);
const NO_WIKI_IMAGES_ERROR = "Add a main image on the right column to continue";
const NO_WIKI_CATEGORIES_ERROR = "Add one category to continue";
const MEDIA_UPLOADING_ERROR = "Some of media are still uploading, please wait";
const EXTERNAL_LINKS_ERROR = "Please remove all external links from the content";
const NO_CITATION_EROR = "Please add at least one citation";
const CONTENT_WORDS_ERROR = (words)=>"Add a minimum of ".concat(MINIMUM_WORDS, " words in the content section to continue. you have written ").concat(words);
const isValidWiki = (toast, wiki)=>{
    const words = getWordCount(wiki.content || "");
    return checkErrors(toast, [
        [
            NO_WIKI_TITLE_ERROR,
            ()=>!wiki.title
        ],
        [
            TITLE_EXCEEDS_LIMIT_ERROR,
            ()=>wiki.title.length > 60
        ],
        [
            NO_WIKI_CONTENT_ERROR,
            ()=>!wiki.content
        ],
        [
            CONTENT_WORDS_ERROR(words),
            ()=>words < MINIMUM_WORDS
        ],
        [
            EXTERNAL_LINKS_ERROR,
            ()=>!(0,textUtils/* isVerifiedContentLinks */.Zw)(wiki.content)
        ],
        [
            NO_WIKI_IMAGES_ERROR,
            ()=>{
                var ref;
                return !((ref = wiki.images) === null || ref === void 0 ? void 0 : ref.length);
            }
        ],
        [
            NO_WIKI_CATEGORIES_ERROR,
            ()=>wiki.categories.length === 0
        ],
        [
            SUMMARY_EXCEEDS_LIMIT_ERROR,
            ()=>isSummaryExceedsLimit(wiki)
        ],
        [
            MEDIA_UPLOADING_ERROR,
            ()=>isMediaUploading(wiki)
        ],
        [
            NO_CITATION_EROR,
            ()=>isCitationInvalid(wiki)
        ]
    ]);
};

;// CONCATENATED MODULE: ./src/utils/CreateWikiUtils/getWikiSlug.ts



const getWikiSlug = async (wiki)=>{
    const slug = (0,textUtils/* slugifyText */.Ei)(String(wiki.title));
    const { data: result  } = await store/* store.dispatch */.h.dispatch(wikis/* getIsWikiSlugValid.initiate */.D6.initiate(slug));
    if (result === null || result === void 0 ? void 0 : result.id) return result.id;
    return slug;
};

;// CONCATENATED MODULE: ./src/utils/CreateWikiUtils/sanitizeContentToPublish.ts

const sanitizeContentToPublish = (content)=>{
    return content.replace(/\n/gm, "  \n").replace(build_module/* EditorContentOverride */.yh, "").replace(/<\/?em>/gm, "*").replace(/<\/?strong>/gm, "**").replace(/<\/?del>/gm, "~~").replace(/<li>/gm, "- ").replace(/<\/li>/gm, "").replace(/<\/?ul>/gm, "").replace(/^(#+\s)(\*\*)(.+)(\*\*)/gm, "$1$3");
};

// EXTERNAL MODULE: ./node_modules/react-canvas-confetti/dist/index.js
var react_canvas_confetti_dist = __webpack_require__("./node_modules/react-canvas-confetti/dist/index.js");
var dist_default = /*#__PURE__*/__webpack_require__.n(react_canvas_confetti_dist);
;// CONCATENATED MODULE: ./src/hooks/useConfetti.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 
function useConfetti() {
    const refAnimationInstance = (0,react.useRef)(null);
    const getInstance = (0,react.useCallback)((instance)=>{
        refAnimationInstance.current = instance;
    }, []);
    const makeShot = (0,react.useCallback)((particleRatio, opts)=>{
        refAnimationInstance.current({
            ...opts,
            origin: {
                y: 0.7
            },
            particleCount: Math.floor(200 * particleRatio)
        });
    }, []);
    const fireConfetti = (0,react.useCallback)(()=>{
        makeShot(0.25, {
            spread: 26,
            startVelocity: 55
        });
        makeShot(0.2, {
            spread: 60
        });
        makeShot(0.35, {
            spread: 100,
            decay: 0.91,
            scalar: 0.8
        });
        makeShot(0.1, {
            spread: 120,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.2
        });
        makeShot(0.1, {
            spread: 120,
            startVelocity: 45
        });
    }, [
        makeShot
    ]);
    const confettiProps = {
        refConfetti: getInstance,
        style: {
            position: "fixed",
            pointerEvents: "none",
            width: "100%",
            height: "100%",
            zIndex: 9999,
            top: 0,
            left: 0
        }
    };
    return {
        fireConfetti,
        confettiProps
    };
}

;// CONCATENATED MODULE: ./src/utils/CreateWikiUtils/isWikiExist.ts



const isWikiExists = async (slug, setExistingWikiData)=>{
    if (slug === build_module/* CreateNewWikiSlug */.M9) return false;
    const { data , isError  } = await store/* store.dispatch */.h.dispatch(wikis/* getWiki.initiate */.Wc.initiate(slug));
    if (isError) return false;
    if (data) {
        setExistingWikiData(data);
        return true;
    }
    return false;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__("./node_modules/@swc/helpers/src/_tagged_template_literal.mjs");
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var graphql_request_dist = __webpack_require__("./node_modules/graphql-request/dist/index.js");
;// CONCATENATED MODULE: ./src/utils/WalletUtils/postSignature.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation Relayer(\n      $ipfs: String!\n      $userAddr: String!\n      $deadline: Float!\n      $v: String!\n      $r: String!\n      $s: String!\n    ) {\n      relayer(\n        txToRelay: {\n          ipfs: $ipfs\n          userAddr: $userAddr\n          deadline: $deadline\n          v: $v\n          r: $r\n          s: $s\n        }\n      ) {\n        hash\n      }\n    }\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const submitVerifiableSignature = async (signedData, wikiHash, address, deadline)=>{
    const signature = signedData.substring(2);
    const r = "0x".concat(signature.substring(0, 64));
    const s = "0x".concat(signature.substring(64, 128));
    const v = parseInt(signature.substring(128, 130), 16);
    // mutation
    const graphQLClient = new graphql_request_dist.GraphQLClient(config/* default.graphqlUrl */.Z.graphqlUrl);
    const mutation = (0,graphql_request_dist.gql)(_templateObject());
    const data = await graphQLClient.request(mutation, {
        ipfs: wikiHash,
        userAddr: address,
        deadline,
        v: v.toString(),
        r: r.toString(),
        s: s.toString()
    });
    return data.relayer.hash;
};

;// CONCATENATED MODULE: ./src/utils/DataTransform/getDeadline.ts
const getDeadline = ()=>{
    const deadline = new Date();
    return Math.floor(deadline.getTime() / 1000.0) + 24 * 60 * 60;
};

;// CONCATENATED MODULE: ./src/utils/CreateWikiUtils/domainType.ts

const domain = {
    name: "EP",
    version: "1",
    chainId: Number(config/* default.chainId */.Z.chainId),
    verifyingContract: config/* default.wikiContractAddress */.Z.wikiContractAddress
};
const types = {
    SignedPost: [
        {
            name: "ipfs",
            type: "string"
        },
        {
            name: "user",
            type: "address"
        },
        {
            name: "deadline",
            type: "uint256"
        }
    ]
};

;// CONCATENATED MODULE: ./src/hooks/useGetSignedHash.ts










const useGetSignedHash = ()=>{
    const { setWikiHash , wikiHash , isNewCreateWiki , setMsg , setIsLoading , setTxHash , setActiveStep , txHash , setCommitMessage , dispatch  } = useCreateWikiContext();
    const { address: userAddress , isConnected: isUserConnected  } = (0,dist/* useAccount */.mA)();
    const deadline = (0,react.useRef)(0);
    const { data: signData , error: signError , isLoading: signing , signTypedDataAsync  } = (0,dist/* useSignTypedData */.yw)();
    const { refetch  } = (0,dist/* useWaitForTransaction */.BX)({
        hash: txHash,
        confirmations: 2
    });
    const { data: feeData  } = (0,dist/* useFeeData */.LK)({
        formatUnits: "gwei"
    });
    const gasPrice = (0,react.useMemo)(()=>{
        return parseFloat((feeData === null || feeData === void 0 ? void 0 : feeData.formatted.gasPrice) || "0");
    }, [
        feeData
    ]);
    const saveHashInTheBlockchain = async (ipfs)=>{
        deadline.current = getDeadline();
        setWikiHash(ipfs);
        signTypedDataAsync({
            primaryType: "SignedPost",
            domain: domain,
            types: types,
            message: {
                ipfs,
                user: userAddress,
                deadline: deadline.current
            }
        }).then((response)=>{
            if (response) {
                setActiveStep(1);
            } else {
                setIsLoading("error");
                setMsg(defaultErrorMessage);
            }
        }).catch((err)=>{
            setIsLoading("error");
            setMsg(err.message || defaultErrorMessage);
            (0,googleAnalytics/* logEvent */.K)({
                action: "SUBMIT_WIKI_ERROR",
                label: err.message,
                category: "wiki_error",
                value: 1
            });
        });
    };
    const verifyTrxHash = (0,react.useCallback)(async ()=>{
        let timePassed = 0;
        const _timer = setInterval(()=>{
            if (timePassed >= 60 * 1000 && gasPrice > 250) {
                setMsg("A little congestion on the polygon chain is causing a delay in the \n          creation of your wiki.This would be resolved in a little while.");
            }
            try {
                const checkTrx = async ()=>{
                    var ref;
                    const trx = await refetch();
                    if (trx.error || ((ref = trx.data) === null || ref === void 0 ? void 0 : ref.status) === "reverted") {
                        setIsLoading("error");
                        setMsg(defaultErrorMessage);
                        (0,googleAnalytics/* logEvent */.K)({
                            action: "SUBMIT_WIKI_ERROR",
                            label: "TRANSACTION_VERIFICATION_ERROR",
                            category: "wiki_error",
                            value: 1
                        });
                        clearInterval(_timer);
                    }
                    if ((trx === null || trx === void 0 ? void 0 : trx.data) && trx.data.status === "success") {
                        setIsLoading(undefined);
                        setActiveStep(3);
                        setMsg(isNewCreateWiki ? successMessage : editedMessage);
                        // clear all edit based metadata from redux state
                        Object.values(build_module/* EditSpecificMetaIds */.F6).forEach((id)=>{
                            dispatch({
                                type: "wiki/updateMetadata",
                                payload: {
                                    id,
                                    value: ""
                                }
                            });
                        });
                        setCommitMessage("");
                        (0,wiki_slice/* removeDraftFromLocalStorage */.j1)();
                        clearInterval(_timer);
                    }
                };
                checkTrx();
            } catch (err) {
                const errorObject = err;
                setIsLoading("error");
                setMsg(defaultErrorMessage);
                (0,googleAnalytics/* logEvent */.K)({
                    action: "SUBMIT_WIKI_ERROR",
                    label: errorObject.message,
                    category: "wiki_error",
                    value: 1
                });
                clearInterval(_timer);
            }
            timePassed += 3000;
        }, 3000);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        refetch
    ]);
    (0,react.useEffect)(()=>{
        const getSignedTxHash = async ()=>{
            if (signData && wikiHash && isUserConnected && userAddress) {
                if (signError) {
                    setMsg(defaultErrorMessage);
                    setIsLoading("error");
                    return;
                }
                try {
                    const hash = await submitVerifiableSignature(signData, wikiHash, userAddress, deadline.current);
                    if (hash) {
                        setTxHash(hash);
                        setActiveStep(2);
                    }
                } catch (err) {
                    const errorObject = err;
                    setIsLoading("error");
                    setMsg(errorObject.response.errors[0].extensions.exception.reason);
                    (0,googleAnalytics/* logEvent */.K)({
                        action: "SUBMIT_WIKI_ERROR",
                        label: errorObject.response.errors[0].extensions.exception.reason,
                        category: "wiki_error",
                        value: 1
                    });
                }
            }
        };
        getSignedTxHash();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        signData,
        signError
    ]);
    return {
        signing,
        saveHashInTheBlockchain,
        verifyTrxHash,
        txHash
    };
};

// EXTERNAL MODULE: ./src/components/Wiki/WikiPreviewCard/WikiPreviewCard.tsx
var WikiPreviewCard = __webpack_require__("./src/components/Wiki/WikiPreviewCard/WikiPreviewCard.tsx");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkButton.tsx
var LinkButton = __webpack_require__("./src/components/Elements/LinkElements/LinkButton.tsx");
;// CONCATENATED MODULE: ./src/components/CreateWiki/EditorModals/OverrideExistingWikiDialog.tsx






const OverrideExistingWikiDialog = (props)=>{
    const { isOpen , onClose , publish , getSlug , existingWikiData  } = props;
    const cancelRef = (0,react.useRef)(null);
    const [slug, setSlug] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        async function getWikiSlug() {
            setSlug(await getSlug());
        }
        getWikiSlug();
    }, [
        getSlug
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* AlertDialog */.aR, {
        motionPreset: "slideInBottom",
        leastDestructiveRef: cancelRef,
        onClose: onClose,
        isOpen: isOpen,
        isCentered: true,
        size: "2xl",
        closeOnOverlayClick: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* AlertDialogOverlay */.dh, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* AlertDialogContent */._T, {
                _dark: {
                    backgroundColor: "gray.800"
                },
                maxW: "min(500px, 90vw)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    p: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* AlertDialogHeader */.fY, {
                            px: "0 !important",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                    spacing: 4,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                            p: 2,
                                            bgColor: "dimColor",
                                            w: "40px",
                                            h: "40px",
                                            borderRadius: "full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                                as: ri_index_esm/* RiErrorWarningFill */.oji,
                                                fontSize: 30
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                            size: "lg",
                                            children: "Warning !"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* IconButton */.hU, {
                                    variant: "unstyled",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "fadedText2",
                                    "aria-label": "Close",
                                    onClick: onClose,
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ri_index_esm/* RiCloseLine */.eSQ, {}),
                                    fontSize: 30
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            align: "center",
                            children: "This wiki is already in existence, creating a new wiki with the same id (Wiki title) will overwrite the existing one."
                        }),
                        existingWikiData && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                maxW: "300px",
                                transform: "scale(0.8)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiPreviewCard/* default */.Z, {
                                    wiki: existingWikiData,
                                    showLatestEditor: false
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* ButtonGroup */.hE, {
                            display: "flex",
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                                    onClick: publish,
                                    children: "Proceed anyways"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* default */.Z, {
                                    href: "/create-wiki?slug=".concat(slug),
                                    variant: "outline",
                                    children: "Edit Wiki"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var EditorModals_OverrideExistingWikiDialog = (OverrideExistingWikiDialog);

// EXTERNAL MODULE: ./node_modules/chakra-ui-steps/dist/chakra-ui-steps.es.js
var chakra_ui_steps_es = __webpack_require__("./node_modules/chakra-ui-steps/dist/chakra-ui-steps.es.js");
;// CONCATENATED MODULE: ./src/components/CreateWiki/EditorModals/WikiProcessModal.tsx







const WikiProcessModal = (props)=>{
    const { onClose , isOpen , activeStep , state , wikiHash , txHash , msg , wikiId , isNewWiki  } = props;
    const cancelRef = react.useRef(null);
    const router = (0,next_router.useRouter)();
    const steps = [
        {
            label: "Signed Wiki"
        },
        {
            label: "Sent to Relayer"
        },
        {
            label: isNewWiki ? "Wiki created" : "Wiki updated"
        }
    ];
    if (!isOpen) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* AlertDialog */.aR, {
            motionPreset: "slideInBottom",
            leastDestructiveRef: cancelRef,
            onClose: onClose,
            isOpen: isOpen,
            isCentered: true,
            size: "2xl",
            closeOnOverlayClick: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* AlertDialogOverlay */.dh, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* AlertDialogContent */._T, {
                    w: {
                        base: "90vw",
                        md: "unset"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        p: 8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        flex: "1",
                                        fontSize: "lg",
                                        fontWeight: "bold",
                                        children: "Transaction Details"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        cursor: "pointer",
                                        fontSize: "2xl",
                                        as: ri_index_esm/* RiCloseLine */.eSQ,
                                        onClick: onClose
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                textAlign: "center",
                                px: 10,
                                pt: 10,
                                justifyContent: "center",
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        mb: "16",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                            flexDir: "column",
                                            width: "100%",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_steps_es/* Steps */.Rg, {
                                                state: state,
                                                labelOrientation: "vertical",
                                                colorScheme: "pink",
                                                activeStep: activeStep,
                                                children: steps.map((param)=>/*#__PURE__*/ {
                                                    let { label  } = param;
                                                    return (0,jsx_runtime.jsx)(chakra_ui_steps_es/* Step */.h8, {
                                                        label: label
                                                    }, label);
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        p: 3,
                                        bg: "pageBg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                            fontSize: "xs",
                                            lineHeight: "2",
                                            children: msg
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        mt: "16",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                                            direction: {
                                                base: "column",
                                                md: "row"
                                            },
                                            spacing: 6,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                                                    onClick: ()=>{
                                                        router.push("/wiki/".concat(wikiId));
                                                    },
                                                    fontSize: "xs",
                                                    colorScheme: "primary",
                                                    disabled: !(activeStep === 3 && state === undefined),
                                                    children: "View Wiki"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                                                    fontSize: "xs",
                                                    fontWeight: "semibold",
                                                    variant: "outline",
                                                    disabled: !wikiHash,
                                                    onClick: ()=>window.open("".concat(config/* default.pinataBaseUrl */.Z.pinataBaseUrl).concat(wikiHash)),
                                                    children: "See on IPFS"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                                                    disabled: !(activeStep === 3 && txHash),
                                                    onClick: ()=>window.open("".concat(config/* default.blockExplorerUrl */.Z.blockExplorerUrl, "/tx/").concat(txHash)),
                                                    variant: "link",
                                                    fontWeight: "semibold",
                                                    fontSize: "xs",
                                                    children: "View on Block Explorer"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var EditorModals_WikiProcessModal = (WikiProcessModal);

;// CONCATENATED MODULE: ./src/components/Elements/Popover/Popover.tsx



const PopoverButton = (param)=>{
    let { header , footer , buttonContents , children , ...rest } = param;
    const { isOpen , onOpen , onClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* Popover */.J2, {
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverTrigger */.xo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                    ...rest,
                    onClick: onOpen,
                    children: buttonContents
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* PopoverContent */.yk, {
                m: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverArrow */.QH, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverCloseButton */.us, {}),
                    header && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverHeader */.Yt, {
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverBody */.b, {
                        children: children
                    }),
                    footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverFooter */.DT, {
                        children: footer
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/CreateWiki/CreateWikiTopBar/WikiPublish/CommitMessageInput.tsx






const commitMessageLimitAlertStyle = {
    sx: {
        bgColor: "#d406082a",
        "&:focus": {
            borderColor: "#ff787c",
            boxShadow: "0 0 0 1px #ff787c"
        }
    }
};
const baseStyle = {
    sx: {
        bgColor: "transparent",
        "&:focus": {
            borderColor: "#63b3ed",
            boxShadow: "0 0 0 1px #63b3ed"
        }
    }
};
const CommitMessageInput = ()=>{
    var ref;
    const [commitMessageLimitAlert, setCommitMessageLimitAlert] = (0,react.useState)(false);
    const metadata = (0,hook/* useAppSelector */.C)((state)=>state.wiki.metadata);
    const commitMessage = (ref = metadata.find((m)=>m.id === build_module/* EditSpecificMetaIds.COMMIT_MESSAGE */.F6.COMMIT_MESSAGE)) === null || ref === void 0 ? void 0 : ref.value;
    const commitMsgCountColor = ()=>{
        let color = "yellow";
        if (commitMessageLimitAlert) {
            color = "red";
        }
        if (((commitMessage === null || commitMessage === void 0 ? void 0 : commitMessage.length) || 0) > 50) color = "green";
        return color;
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(tag_dist_index_esm/* Tag */.Vp, {
                mb: {
                    base: 2,
                    lg: 2
                },
                variant: "solid",
                colorScheme: commitMsgCountColor(),
                children: [
                    (commitMessage === null || commitMessage === void 0 ? void 0 : commitMessage.length) || 0,
                    "/128"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, {
                value: commitMessage,
                placeholder: "Enter what changed...",
                ...commitMessageLimitAlert ? commitMessageLimitAlertStyle : baseStyle,
                onChange: (e)=>{
                    if (e.target.value.length <= 128) {
                        dispatch({
                            type: "wiki/updateMetadata",
                            payload: {
                                id: build_module/* EditSpecificMetaIds.COMMIT_MESSAGE */.F6.COMMIT_MESSAGE,
                                value: e.target.value
                            }
                        });
                    } else {
                        setCommitMessageLimitAlert(true);
                        setTimeout(()=>setCommitMessageLimitAlert(false), 2000);
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/CreateWiki/CreateWikiTopBar/WikiPublish/WikiPublishWithCommitMessage.tsx







const CommitMessagePopOverFooter = (param)=>{
    let { handleSubmitWiki  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        spacing: 2,
        justify: "right",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                onClick: ()=>{
                    dispatch({
                        type: "wiki/updateMetadata",
                        payload: {
                            id: build_module/* EditSpecificMetaIds.COMMIT_MESSAGE */.F6.COMMIT_MESSAGE,
                            value: ""
                        }
                    });
                    handleSubmitWiki();
                },
                float: "right",
                variant: "outline",
                children: "Skip"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                onClick: handleSubmitWiki,
                children: "Submit"
            })
        ]
    });
};
const PublishWithCommitMessage = (param)=>{
    let { handleWikiPublish , isPublishDisabled , submittingWiki  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverButton, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
            fontSize: "sm",
            fontWeight: "bold",
            children: [
                "Commit Message ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    children: "(Optional)"
                })
            ]
        }),
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitMessagePopOverFooter, {
            handleSubmitWiki: handleWikiPublish
        }),
        buttonContents: "Publish",
        isLoading: submittingWiki,
        _disabled: {
            opacity: isPublishDisabled ? 0.5 : undefined,
            _hover: {
                bgColor: "grey !important",
                cursor: "not-allowed"
            }
        },
        loadingText: "Loading",
        disabled: isPublishDisabled,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitMessageInput, {})
    });
};

// EXTERNAL MODULE: ./src/data/NetworkMap.ts
var NetworkMap = __webpack_require__("./src/data/NetworkMap.ts");
// EXTERNAL MODULE: ./node_modules/@metamask/detect-provider/dist/index.js
var detect_provider_dist = __webpack_require__("./node_modules/@metamask/detect-provider/dist/index.js");
var detect_provider_dist_default = /*#__PURE__*/__webpack_require__.n(detect_provider_dist);
;// CONCATENATED MODULE: ./src/components/CreateWiki/CreateWikiTopBar/WikiPublish/WikiPublishButton.tsx



























const NetworkErrorNotification = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9122).then(__webpack_require__.bind(__webpack_require__, "./src/components/Layout/Network/NetworkErrorNotification.tsx")), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/("./src/components/Layout/Network/NetworkErrorNotification.tsx")
            ]
    }
});
const WikiPublishButton = ()=>{
    const wiki = (0,hook/* useAppSelector */.C)((state)=>state.wiki);
    const [submittingWiki, setSubmittingWiki] = (0,hooks_dist_index_esm/* useBoolean */.kt)();
    const { address: userAddress , isConnected: isUserConnected  } = (0,dist/* useAccount */.mA)();
    const { userCanEdit  } = useWhiteListValidator(userAddress);
    const [connectedChainId, setConnectedChainId] = (0,react.useState)();
    const [showNetworkModal, setShowNetworkModal] = (0,react.useState)(false);
    const { chainId  } = config/* default.alchemyChain */.Z.alchemyChain === "maticmum" ? NetworkMap/* default.MUMBAI_TESTNET */.Z.MUMBAI_TESTNET : NetworkMap/* default.POLYGON_MAINNET */.Z.POLYGON_MAINNET;
    const [detectedProvider, setDetectedProvider] = (0,react.useState)(null);
    const { isOpen: isOverrideModalOpen , onOpen: onOverrideModalOpen , onClose: onOverrideModalClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const { isOpen: isWikiProcessModalOpen , onOpen: onWikiProcessModalOpen , onClose: onWikiProcessModalClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const { dispatch , toast , wikiHash , revision , isNewCreateWiki , existingWikiData , setExistingWikiData , activeStep , setActiveStep , loadingState , setIsLoading , wikiId , setWikiId , msg , setMsg , wikiData , isLoadingWiki  } = useCreateWikiContext();
    const prevEditedWiki = (0,react.useRef)({
        wiki: wikiData,
        isPublished: false
    });
    const { saveHashInTheBlockchain , verifyTrxHash , signing , txHash  } = useGetSignedHash();
    const isPublishDisabled = submittingWiki || !userAddress || signing || isLoadingWiki || !userCanEdit;
    const { fireConfetti , confettiProps  } = useConfetti();
    (0,react.useEffect)(()=>{
        const getConnectedChain = async (provider)=>{
            const connectedChainId = await provider.request({
                method: "eth_chainId"
            });
            setConnectedChainId(connectedChainId);
        };
        const getDetectedProvider = async ()=>{
            const provider = await detect_provider_dist_default()({
                silent: true
            });
            setDetectedProvider(provider);
            if (provider) getConnectedChain(provider);
        };
        if (!detectedProvider) {
            getDetectedProvider();
        } else {
            getConnectedChain(detectedProvider);
            detectedProvider.on("chainChanged", (newlyConnectedChain)=>setConnectedChainId(newlyConnectedChain));
        }
        return ()=>{
            if (detectedProvider) {
                detectedProvider.removeListener("chainChanged", (newlyConnectedChain)=>setConnectedChainId(newlyConnectedChain));
            }
        };
    }, [
        detectedProvider,
        isUserConnected
    ]);
    (0,react.useEffect)(()=>{
        if (activeStep === 3) {
            prevEditedWiki.current.isPublished = true;
            fireConfetti();
        }
    }, [
        activeStep,
        fireConfetti
    ]);
    (0,react.useEffect)(()=>{
        async function verifyTransactionHash() {
            if (txHash) verifyTrxHash();
        }
        verifyTransactionHash();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        txHash,
        verifyTrxHash
    ]);
    const processWikiPublishError = async (wikiResult)=>{
        setIsLoading("error");
        let logReason = "NO_IPFS";
        if (wikiResult && "error" in wikiResult) {
            const rawErrMsg = wikiResult.error.message;
            const prefix = "Http Exception:";
            if (rawErrMsg === null || rawErrMsg === void 0 ? void 0 : rawErrMsg.startsWith(prefix)) {
                const errObjString = rawErrMsg.substring(prefix.length);
                const errObj = JSON.parse(errObjString);
                // eslint-disable-next-line no-console
                console.error({
                    ...errObj
                });
                const wikiError = errObj.response.errors[0].extensions.exception.response;
                logReason = wikiError.error;
                setMsg(ValidationErrorMessage(logReason));
            } else {
                setMsg(defaultErrorMessage);
            }
        }
        (0,googleAnalytics/* logEvent */.K)({
            action: "SUBMIT_WIKI_ERROR",
            label: await getWikiSlug(wiki),
            category: "wiki_error",
            value: 1
        });
    };
    const updateCommitMessage = (override)=>{
        var ref;
        let wikiCommitMessage = (ref = (0,getWikiFields/* getWikiMetadataById */.lU)(wiki, build_module/* EditSpecificMetaIds.COMMIT_MESSAGE */.F6.COMMIT_MESSAGE)) === null || ref === void 0 ? void 0 : ref.value;
        if (isNewCreateWiki) {
            if (override) {
                wikiCommitMessage = "Wiki Overridden \uD83D\uDD04";
            } else if (revision) {
                wikiCommitMessage = "Reverted to revision ".concat(revision, " ⏪");
            } else {
                wikiCommitMessage = "New Wiki Created \uD83C\uDF89";
            }
        }
        dispatch({
            type: "wiki/updateMetadata",
            payload: {
                id: build_module/* EditSpecificMetaIds.COMMIT_MESSAGE */.F6.COMMIT_MESSAGE,
                value: wikiCommitMessage
            }
        });
    };
    const handleWikiPublish = async (override)=>{
        if (connectedChainId !== chainId) {
            setShowNetworkModal(true);
            return;
        }
        if (!isValidWiki(toast, wiki)) return;
        (0,googleAnalytics/* logEvent */.K)({
            action: "SUBMIT_WIKI",
            label: await getWikiSlug(wiki),
            category: "wiki_title",
            value: 1
        });
        if (isUserConnected && userAddress) {
            const ifWikiExists = isNewCreateWiki && !override && await isWikiExists(await getWikiSlug(wiki), setExistingWikiData);
            if (ifWikiExists) {
                onOverrideModalOpen();
                return;
            }
            updateCommitMessage(!!override);
            onWikiProcessModalOpen();
            setSubmittingWiki.on();
            const finalWiki = {
                ...wiki,
                user: {
                    id: userAddress
                },
                content: sanitizeContentToPublish(String(wiki.content)),
                metadata: wiki.metadata.filter((m)=>m.value)
            };
            if (finalWiki.id === build_module/* CreateNewWikiSlug */.M9) finalWiki.id = await getWikiSlug(wiki);
            setWikiId(finalWiki.id);
            prevEditedWiki.current = {
                wiki: finalWiki,
                isPublished: false
            };
            const wikiResult = await store/* store.dispatch */.h.dispatch(wikis/* postWiki.initiate */.tI.initiate({
                data: finalWiki
            }));
            if (wikiResult && "data" in wikiResult) {
                saveHashInTheBlockchain(String(wikiResult.data));
            } else {
                await processWikiPublishError(wikiResult);
            }
            setSubmittingWiki.off();
        }
    };
    const handlePopupClose = ()=>{
        setMsg(initialMsg);
        setIsLoading("loading");
        setActiveStep(0);
        onWikiProcessModalClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_dist_index_esm/* Tooltip */.u, {
                isDisabled: !!userCanEdit,
                p: 2,
                rounded: "md",
                placement: "bottom-start",
                shouldWrapChildren: true,
                color: "white",
                bg: "toolTipBg",
                hasArrow: true,
                label: "Your address is not yet whitelisted",
                mt: "3",
                children: !isNewCreateWiki ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PublishWithCommitMessage, {
                    handleWikiPublish: ()=>handleWikiPublish(),
                    isPublishDisabled: isPublishDisabled,
                    submittingWiki: false
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                    onClick: ()=>handleWikiPublish(),
                    disabled: !userCanEdit,
                    _disabled: {
                        opacity: isPublishDisabled ? 0.5 : undefined,
                        _hover: {
                            bgColor: "grey !important",
                            cursor: "not-allowed"
                        }
                    },
                    children: "Publish"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorModals_OverrideExistingWikiDialog, {
                isOpen: isOverrideModalOpen,
                publish: ()=>{
                    onOverrideModalClose();
                    handleWikiPublish(true);
                },
                onClose: onOverrideModalClose,
                getSlug: ()=>getWikiSlug(wiki),
                existingWikiData: existingWikiData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorModals_WikiProcessModal, {
                wikiId: wikiId,
                msg: msg,
                txHash: txHash,
                wikiHash: wikiHash,
                activeStep: activeStep,
                isNewWiki: isNewCreateWiki,
                state: loadingState,
                isOpen: isWikiProcessModalOpen,
                onClose: handlePopupClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                ...confettiProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NetworkErrorNotification, {
                modalState: showNetworkModal,
                setModalState: (state)=>setShowNetworkModal(state)
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/CreateWiki/CreateWikiTopBar/index.tsx






const CreateWikiTopBar = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
        boxShadow: "sm",
        borderRadius: 4,
        borderWidth: "1px",
        p: 3,
        justifyContent: "space-between",
        mx: "auto",
        mb: 3,
        mt: 2,
        w: "96%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiTitleInput, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                gap: 5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateWikiTopBar_WikiScoreIndicator, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiPublishButton, {})
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/WrapperRoutes/AuthenticatedRoute.tsx
var AuthenticatedRoute = __webpack_require__("./src/components/WrapperRoutes/AuthenticatedRoute.tsx");
;// CONCATENATED MODULE: ./src/pages/create-wiki/index.tsx
















const Editor = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(5974), __webpack_require__.e(5453), __webpack_require__.e(8562), __webpack_require__.e(6910), __webpack_require__.e(7989), __webpack_require__.e(6712)]).then(__webpack_require__.bind(__webpack_require__, "./src/components/CreateWiki/Editor.tsx")), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/("./src/components/CreateWiki/Editor.tsx")
            ]
    },
    ssr: false
});
const CreateWikiContent = ()=>{
    var ref;
    const wiki = (0,hook/* useAppSelector */.C)((state)=>state.wiki);
    const { isLoadingWiki , wikiData , setCommitMessage , dispatch , toast , revision , isNewCreateWiki , txError , setTxError  } = useCreateWikiContext();
    const handleOnEditorChanges = (val, isInitSet)=>{
        if (isInitSet) dispatch({
            type: "wiki/setInitialWikiState",
            payload: {
                content: val || " "
            }
        });
        else dispatch({
            type: "wiki/setContent",
            payload: val || " "
        });
    };
    useCreateWikiEffects();
    (0,react.useEffect)(()=>{
        // get draft wiki if it exists
        let draft;
        if (isNewCreateWiki) draft = (0,wiki_slice/* getDraftFromLocalStorage */.ON)();
        else if (wikiData) draft = (0,wiki_slice/* getDraftFromLocalStorage */.ON)();
        if (!toast.isActive("draft-loaded") && draft) {
            toast({
                id: "draft-loaded",
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                    w: "full",
                    justify: "space-between",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            children: "Loaded from saved draft"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                            size: "xs",
                            variant: "outline",
                            onClick: ()=>{
                                (0,wiki_slice/* removeDraftFromLocalStorage */.j1)();
                                // reload the page to remove the draft
                                window.location.reload();
                            },
                            sx: {
                                "&:hover, &:focus, &:active": {
                                    bgColor: "#0000002a"
                                }
                            },
                            children: (draft === null || draft === void 0 ? void 0 : draft.id) === build_module/* CreateNewWikiSlug */.M9 ? "Reset State" : "Reset to current wiki content"
                        })
                    ]
                }),
                status: "info",
                duration: 5000
            });
        }
    }, [
        isNewCreateWiki,
        toast,
        wikiData
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        let initWikiData;
        if (wikiData) initWikiData = (0,wiki_slice/* getDraftFromLocalStorage */.ON)();
        // combine draft wiki data with existing wikidata images
        // if the draft doesn't modify the images
        if (initWikiData && wikiData && !initWikiData.images) {
            if (wikiData.images && wikiData.images.length > 0) initWikiData.images = wikiData.images;
        }
        // if there is no draft stored, use fetched wiki data
        if (!initWikiData) initWikiData = wikiData;
        if (initWikiData && (initWikiData === null || initWikiData === void 0 ? void 0 : (ref = initWikiData.content) === null || ref === void 0 ? void 0 : ref.length) > 0 && (initWikiData === null || initWikiData === void 0 ? void 0 : initWikiData.images) && (initWikiData === null || initWikiData === void 0 ? void 0 : (ref1 = initWikiData.images) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            let { metadata  } = initWikiData;
            // fetch the currently stored meta data of page that are not edit specific
            // (commonMetaIds) and append edit specific meta data (editMetaIds) with empty values
            const wikiDt = initWikiData;
            metadata = [
                ...Object.values(build_module/* CommonMetaIds */.wA).map((mId)=>{
                    const meta = (0,getWikiFields/* getWikiMetadataById */.lU)(wikiDt, mId);
                    return {
                        id: mId,
                        value: (meta === null || meta === void 0 ? void 0 : meta.value) || ""
                    };
                }),
                ...Object.values(build_module/* EditSpecificMetaIds */.F6).map((mId)=>({
                        id: mId,
                        value: ""
                    }))
            ];
            if (revision) {
                setCommitMessage("Reverted to revision ".concat(revision, " ⏪"));
            }
            dispatch({
                type: "wiki/setInitialWikiState",
                payload: {
                    ...initWikiData,
                    content: build_module/* EditorContentOverride */.yh + initWikiData.content.replace(/ {2}\n/gm, "\n"),
                    metadata
                }
            });
        }
    }, [
        dispatch,
        revision,
        setCommitMessage,
        toast,
        wikiData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateWikiPage, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                scrollBehavior: "auto",
                maxW: "1900px",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateWikiTopBar, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        flexDirection: {
                            base: "column",
                            xl: "row"
                        },
                        justify: "center",
                        align: "stretch",
                        gap: 4,
                        px: {
                            base: 4,
                            xl: 8
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                h: "full",
                                w: "full",
                                position: {
                                    xl: "sticky"
                                },
                                top: "90px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    isLoaded: !isLoadingWiki,
                                    w: "full",
                                    h: "75vh",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
                                        markdown: wiki.content,
                                        onChange: handleOnEditorChanges
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    isLoaded: !isLoadingWiki,
                                    w: "full",
                                    h: "full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateWiki_WikiDetailsSidebar, {
                                            initialImage: (wiki === null || wiki === void 0 ? void 0 : (ref = wiki.images) === null || ref === void 0 ? void 0 : ref.length) ? wiki.images[0].id : "",
                                            isToResetImage: isNewCreateWiki
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                        isLoaded: !isLoadingWiki,
                        w: "full",
                        h: "full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TxError, {
                            txError: txError,
                            setTxError: setTxError
                        })
                    })
                ]
            })
        ]
    });
};
const CreateWiki = ()=>{
    const router = (0,next_router.useRouter)();
    const wikiState = useCreateWikiState(router);
    const providerValue = (0,react.useMemo)(()=>wikiState, [
        wikiState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateWikiProvider, {
        value: providerValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateWikiContent, {})
    });
};
const Page = (0,AuthenticatedRoute/* authenticatedRoute */.H)(CreateWiki);
Page.noFooter = true;
var __N_SSP = true;
/* harmony default export */ var create_wiki = (Page);


/***/ }),

/***/ "./src/utils/CreateWikiUtils/saveImage.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ saveImage; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/config/index.ts");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _services_wikis_queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/services/wikis/queries.ts");



const saveImage = async (image)=>{
    const formData = new FormData();
    const blob = new Blob([
        image.type
    ], {
        type: "image/jpeg"
    });
    formData.append("operations", _services_wikis_queries__WEBPACK_IMPORTED_MODULE_2__/* .POST_IMG */ .o0);
    formData.append("map", '{"0": ["variables.file"]}');
    formData.append("0", blob);
    try {
        const { data: { data: { pinImage: { IpfsHash  }  }  }  } = await axios__WEBPACK_IMPORTED_MODULE_1___default().post(_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].graphqlUrl */ .Z.graphqlUrl, formData, {});
        return IpfsHash;
    } catch (_err) {
        return null;
    }
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,1228,4617,5675,2192,7249,8764,5619,4095,6788,6422,2082,557,5172,145,8283,3702,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Fcreate-wiki%2Findex.tsx&page=%2Fcreate-wiki!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);